// Auto-generated by scripts/generate_species_map.mjs from "blitz files/species.h".
// Do not edit by hand. Regenerate after changing the ROM species list.
export interface SpeciesInfo {
  name: string;
  icon: string;
  baseId: number;
  form: string;
}

export const SPECIES_BY_ID: Record<number, SpeciesInfo> = {
  1: { name: "Bulbasaur", icon: "bulbasaur", baseId: 1, form: "" },
  2: { name: "Ivysaur", icon: "ivysaur", baseId: 2, form: "" },
  3: { name: "Venusaur", icon: "venusaur", baseId: 3, form: "" },
  4: { name: "Charmander", icon: "charmander", baseId: 4, form: "" },
  5: { name: "Charmeleon", icon: "charmeleon", baseId: 5, form: "" },
  6: { name: "Charizard", icon: "charizard", baseId: 6, form: "" },
  7: { name: "Squirtle", icon: "squirtle", baseId: 7, form: "" },
  8: { name: "Wartortle", icon: "wartortle", baseId: 8, form: "" },
  9: { name: "Blastoise", icon: "blastoise", baseId: 9, form: "" },
  10: { name: "Caterpie", icon: "caterpie", baseId: 10, form: "" },
  11: { name: "Metapod", icon: "metapod", baseId: 11, form: "" },
  12: { name: "Butterfree", icon: "butterfree", baseId: 12, form: "" },
  13: { name: "Weedle", icon: "weedle", baseId: 13, form: "" },
  14: { name: "Kakuna", icon: "kakuna", baseId: 14, form: "" },
  15: { name: "Beedrill", icon: "beedrill", baseId: 15, form: "" },
  16: { name: "Pidgey", icon: "pidgey", baseId: 16, form: "" },
  17: { name: "Pidgeotto", icon: "pidgeotto", baseId: 17, form: "" },
  18: { name: "Pidgeot", icon: "pidgeot", baseId: 18, form: "" },
  19: { name: "Rattata", icon: "rattata", baseId: 19, form: "" },
  20: { name: "Raticate", icon: "raticate", baseId: 20, form: "" },
  21: { name: "Spearow", icon: "spearow", baseId: 21, form: "" },
  22: { name: "Fearow", icon: "fearow", baseId: 22, form: "" },
  23: { name: "Ekans", icon: "ekans", baseId: 23, form: "" },
  24: { name: "Arbok", icon: "arbok", baseId: 24, form: "" },
  25: { name: "Pikachu", icon: "pikachu", baseId: 25, form: "" },
  26: { name: "Raichu", icon: "raichu", baseId: 26, form: "" },
  27: { name: "Sandshrew", icon: "sandshrew", baseId: 27, form: "" },
  28: { name: "Sandslash", icon: "sandslash", baseId: 28, form: "" },
  29: { name: "Nidoran-F", icon: "nidoran-f", baseId: 29, form: "" },
  30: { name: "Nidorina", icon: "nidorina", baseId: 30, form: "" },
  31: { name: "Nidoqueen", icon: "nidoqueen", baseId: 31, form: "" },
  32: { name: "Nidoran-M", icon: "nidoran-m", baseId: 32, form: "" },
  33: { name: "Nidorino", icon: "nidorino", baseId: 33, form: "" },
  34: { name: "Nidoking", icon: "nidoking", baseId: 34, form: "" },
  35: { name: "Clefairy", icon: "clefairy", baseId: 35, form: "" },
  36: { name: "Clefable", icon: "clefable", baseId: 36, form: "" },
  37: { name: "Vulpix", icon: "vulpix", baseId: 37, form: "" },
  38: { name: "Ninetales", icon: "ninetales", baseId: 38, form: "" },
  39: { name: "Jigglypuff", icon: "jigglypuff", baseId: 39, form: "" },
  40: { name: "Wigglytuff", icon: "wigglytuff", baseId: 40, form: "" },
  41: { name: "Zubat", icon: "zubat", baseId: 41, form: "" },
  42: { name: "Golbat", icon: "golbat", baseId: 42, form: "" },
  43: { name: "Oddish", icon: "oddish", baseId: 43, form: "" },
  44: { name: "Gloom", icon: "gloom", baseId: 44, form: "" },
  45: { name: "Vileplume", icon: "vileplume", baseId: 45, form: "" },
  46: { name: "Paras", icon: "paras", baseId: 46, form: "" },
  47: { name: "Parasect", icon: "parasect", baseId: 47, form: "" },
  48: { name: "Venonat", icon: "venonat", baseId: 48, form: "" },
  49: { name: "Venomoth", icon: "venomoth", baseId: 49, form: "" },
  50: { name: "Diglett", icon: "diglett", baseId: 50, form: "" },
  51: { name: "Dugtrio", icon: "dugtrio", baseId: 51, form: "" },
  52: { name: "Meowth", icon: "meowth", baseId: 52, form: "" },
  53: { name: "Persian", icon: "persian", baseId: 53, form: "" },
  54: { name: "Psyduck", icon: "psyduck", baseId: 54, form: "" },
  55: { name: "Golduck", icon: "golduck", baseId: 55, form: "" },
  56: { name: "Mankey", icon: "mankey", baseId: 56, form: "" },
  57: { name: "Primeape", icon: "primeape", baseId: 57, form: "" },
  58: { name: "Growlithe", icon: "growlithe", baseId: 58, form: "" },
  59: { name: "Arcanine", icon: "arcanine", baseId: 59, form: "" },
  60: { name: "Poliwag", icon: "poliwag", baseId: 60, form: "" },
  61: { name: "Poliwhirl", icon: "poliwhirl", baseId: 61, form: "" },
  62: { name: "Poliwrath", icon: "poliwrath", baseId: 62, form: "" },
  63: { name: "Abra", icon: "abra", baseId: 63, form: "" },
  64: { name: "Kadabra", icon: "kadabra", baseId: 64, form: "" },
  65: { name: "Alakazam", icon: "alakazam", baseId: 65, form: "" },
  66: { name: "Machop", icon: "machop", baseId: 66, form: "" },
  67: { name: "Machoke", icon: "machoke", baseId: 67, form: "" },
  68: { name: "Machamp", icon: "machamp", baseId: 68, form: "" },
  69: { name: "Bellsprout", icon: "bellsprout", baseId: 69, form: "" },
  70: { name: "Weepinbell", icon: "weepinbell", baseId: 70, form: "" },
  71: { name: "Victreebel", icon: "victreebel", baseId: 71, form: "" },
  72: { name: "Tentacool", icon: "tentacool", baseId: 72, form: "" },
  73: { name: "Tentacruel", icon: "tentacruel", baseId: 73, form: "" },
  74: { name: "Geodude", icon: "geodude", baseId: 74, form: "" },
  75: { name: "Graveler", icon: "graveler", baseId: 75, form: "" },
  76: { name: "Golem", icon: "golem", baseId: 76, form: "" },
  77: { name: "Ponyta", icon: "ponyta", baseId: 77, form: "" },
  78: { name: "Rapidash", icon: "rapidash", baseId: 78, form: "" },
  79: { name: "Slowpoke", icon: "slowpoke", baseId: 79, form: "" },
  80: { name: "Slowbro", icon: "slowbro", baseId: 80, form: "" },
  81: { name: "Magnemite", icon: "magnemite", baseId: 81, form: "" },
  82: { name: "Magneton", icon: "magneton", baseId: 82, form: "" },
  83: { name: "Farfetch'd", icon: "farfetch'd", baseId: 83, form: "" },
  84: { name: "Doduo", icon: "doduo", baseId: 84, form: "" },
  85: { name: "Dodrio", icon: "dodrio", baseId: 85, form: "" },
  86: { name: "Seel", icon: "seel", baseId: 86, form: "" },
  87: { name: "Dewgong", icon: "dewgong", baseId: 87, form: "" },
  88: { name: "Grimer", icon: "grimer", baseId: 88, form: "" },
  89: { name: "Muk", icon: "muk", baseId: 89, form: "" },
  90: { name: "Shellder", icon: "shellder", baseId: 90, form: "" },
  91: { name: "Cloyster", icon: "cloyster", baseId: 91, form: "" },
  92: { name: "Gastly", icon: "gastly", baseId: 92, form: "" },
  93: { name: "Haunter", icon: "haunter", baseId: 93, form: "" },
  94: { name: "Gengar", icon: "gengar", baseId: 94, form: "" },
  95: { name: "Onix", icon: "onix", baseId: 95, form: "" },
  96: { name: "Drowzee", icon: "drowzee", baseId: 96, form: "" },
  97: { name: "Hypno", icon: "hypno", baseId: 97, form: "" },
  98: { name: "Krabby", icon: "krabby", baseId: 98, form: "" },
  99: { name: "Kingler", icon: "kingler", baseId: 99, form: "" },
  100: { name: "Voltorb", icon: "voltorb", baseId: 100, form: "" },
  101: { name: "Electrode", icon: "electrode", baseId: 101, form: "" },
  102: { name: "Exeggcute", icon: "exeggcute", baseId: 102, form: "" },
  103: { name: "Exeggutor", icon: "exeggutor", baseId: 103, form: "" },
  104: { name: "Cubone", icon: "cubone", baseId: 104, form: "" },
  105: { name: "Marowak", icon: "marowak", baseId: 105, form: "" },
  106: { name: "Hitmonlee", icon: "hitmonlee", baseId: 106, form: "" },
  107: { name: "Hitmonchan", icon: "hitmonchan", baseId: 107, form: "" },
  108: { name: "Lickitung", icon: "lickitung", baseId: 108, form: "" },
  109: { name: "Koffing", icon: "koffing", baseId: 109, form: "" },
  110: { name: "Weezing", icon: "weezing", baseId: 110, form: "" },
  111: { name: "Rhyhorn", icon: "rhyhorn", baseId: 111, form: "" },
  112: { name: "Rhydon", icon: "rhydon", baseId: 112, form: "" },
  113: { name: "Chansey", icon: "chansey", baseId: 113, form: "" },
  114: { name: "Tangela", icon: "tangela", baseId: 114, form: "" },
  115: { name: "Kangaskhan", icon: "kangaskhan", baseId: 115, form: "" },
  116: { name: "Horsea", icon: "horsea", baseId: 116, form: "" },
  117: { name: "Seadra", icon: "seadra", baseId: 117, form: "" },
  118: { name: "Goldeen", icon: "goldeen", baseId: 118, form: "" },
  119: { name: "Seaking", icon: "seaking", baseId: 119, form: "" },
  120: { name: "Staryu", icon: "staryu", baseId: 120, form: "" },
  121: { name: "Starmie", icon: "starmie", baseId: 121, form: "" },
  122: { name: "Mr. Mime", icon: "mr-mime", baseId: 122, form: "" },
  123: { name: "Scyther", icon: "scyther", baseId: 123, form: "" },
  124: { name: "Jynx", icon: "jynx", baseId: 124, form: "" },
  125: { name: "Electabuzz", icon: "electabuzz", baseId: 125, form: "" },
  126: { name: "Magmar", icon: "magmar", baseId: 126, form: "" },
  127: { name: "Pinsir", icon: "pinsir", baseId: 127, form: "" },
  128: { name: "Tauros", icon: "tauros", baseId: 128, form: "" },
  129: { name: "Magikarp", icon: "magikarp", baseId: 129, form: "" },
  130: { name: "Gyarados", icon: "gyarados", baseId: 130, form: "" },
  131: { name: "Lapras", icon: "lapras", baseId: 131, form: "" },
  132: { name: "Ditto", icon: "ditto", baseId: 132, form: "" },
  133: { name: "Eevee", icon: "eevee", baseId: 133, form: "" },
  134: { name: "Vaporeon", icon: "vaporeon", baseId: 134, form: "" },
  135: { name: "Jolteon", icon: "jolteon", baseId: 135, form: "" },
  136: { name: "Flareon", icon: "flareon", baseId: 136, form: "" },
  137: { name: "Porygon", icon: "porygon", baseId: 137, form: "" },
  138: { name: "Omanyte", icon: "omanyte", baseId: 138, form: "" },
  139: { name: "Omastar", icon: "omastar", baseId: 139, form: "" },
  140: { name: "Kabuto", icon: "kabuto", baseId: 140, form: "" },
  141: { name: "Kabutops", icon: "kabutops", baseId: 141, form: "" },
  142: { name: "Aerodactyl", icon: "aerodactyl", baseId: 142, form: "" },
  143: { name: "Snorlax", icon: "snorlax", baseId: 143, form: "" },
  144: { name: "Articuno", icon: "articuno", baseId: 144, form: "" },
  145: { name: "Zapdos", icon: "zapdos", baseId: 145, form: "" },
  146: { name: "Moltres", icon: "moltres", baseId: 146, form: "" },
  147: { name: "Dratini", icon: "dratini", baseId: 147, form: "" },
  148: { name: "Dragonair", icon: "dragonair", baseId: 148, form: "" },
  149: { name: "Dragonite", icon: "dragonite", baseId: 149, form: "" },
  150: { name: "Mewtwo", icon: "mewtwo", baseId: 150, form: "" },
  151: { name: "Mew", icon: "mew", baseId: 151, form: "" },
  152: { name: "Chikorita", icon: "chikorita", baseId: 152, form: "" },
  153: { name: "Bayleef", icon: "bayleef", baseId: 153, form: "" },
  154: { name: "Meganium", icon: "meganium", baseId: 154, form: "" },
  155: { name: "Cyndaquil", icon: "cyndaquil", baseId: 155, form: "" },
  156: { name: "Quilava", icon: "quilava", baseId: 156, form: "" },
  157: { name: "Typhlosion", icon: "typhlosion", baseId: 157, form: "" },
  158: { name: "Totodile", icon: "totodile", baseId: 158, form: "" },
  159: { name: "Croconaw", icon: "croconaw", baseId: 159, form: "" },
  160: { name: "Feraligatr", icon: "feraligatr", baseId: 160, form: "" },
  161: { name: "Sentret", icon: "sentret", baseId: 161, form: "" },
  162: { name: "Furret", icon: "furret", baseId: 162, form: "" },
  163: { name: "Hoothoot", icon: "hoothoot", baseId: 163, form: "" },
  164: { name: "Noctowl", icon: "noctowl", baseId: 164, form: "" },
  165: { name: "Ledyba", icon: "ledyba", baseId: 165, form: "" },
  166: { name: "Ledian", icon: "ledian", baseId: 166, form: "" },
  167: { name: "Spinarak", icon: "spinarak", baseId: 167, form: "" },
  168: { name: "Ariados", icon: "ariados", baseId: 168, form: "" },
  169: { name: "Crobat", icon: "crobat", baseId: 169, form: "" },
  170: { name: "Chinchou", icon: "chinchou", baseId: 170, form: "" },
  171: { name: "Lanturn", icon: "lanturn", baseId: 171, form: "" },
  172: { name: "Pichu", icon: "pichu", baseId: 172, form: "" },
  173: { name: "Cleffa", icon: "cleffa", baseId: 173, form: "" },
  174: { name: "Igglybuff", icon: "igglybuff", baseId: 174, form: "" },
  175: { name: "Togepi", icon: "togepi", baseId: 175, form: "" },
  176: { name: "Togetic", icon: "togetic", baseId: 176, form: "" },
  177: { name: "Natu", icon: "natu", baseId: 177, form: "" },
  178: { name: "Xatu", icon: "xatu", baseId: 178, form: "" },
  179: { name: "Mareep", icon: "mareep", baseId: 179, form: "" },
  180: { name: "Flaaffy", icon: "flaaffy", baseId: 180, form: "" },
  181: { name: "Ampharos", icon: "ampharos", baseId: 181, form: "" },
  182: { name: "Bellossom", icon: "bellossom", baseId: 182, form: "" },
  183: { name: "Marill", icon: "marill", baseId: 183, form: "" },
  184: { name: "Azumarill", icon: "azumarill", baseId: 184, form: "" },
  185: { name: "Sudowoodo", icon: "sudowoodo", baseId: 185, form: "" },
  186: { name: "Politoed", icon: "politoed", baseId: 186, form: "" },
  187: { name: "Hoppip", icon: "hoppip", baseId: 187, form: "" },
  188: { name: "Skiploom", icon: "skiploom", baseId: 188, form: "" },
  189: { name: "Jumpluff", icon: "jumpluff", baseId: 189, form: "" },
  190: { name: "Aipom", icon: "aipom", baseId: 190, form: "" },
  191: { name: "Sunkern", icon: "sunkern", baseId: 191, form: "" },
  192: { name: "Sunflora", icon: "sunflora", baseId: 192, form: "" },
  193: { name: "Yanma", icon: "yanma", baseId: 193, form: "" },
  194: { name: "Wooper", icon: "wooper", baseId: 194, form: "" },
  195: { name: "Quagsire", icon: "quagsire", baseId: 195, form: "" },
  196: { name: "Espeon", icon: "espeon", baseId: 196, form: "" },
  197: { name: "Umbreon", icon: "umbreon", baseId: 197, form: "" },
  198: { name: "Murkrow", icon: "murkrow", baseId: 198, form: "" },
  199: { name: "Slowking", icon: "slowking", baseId: 199, form: "" },
  200: { name: "Misdreavus", icon: "misdreavus", baseId: 200, form: "" },
  201: { name: "Unown", icon: "unown", baseId: 201, form: "" },
  202: { name: "Wobbuffet", icon: "wobbuffet", baseId: 202, form: "" },
  203: { name: "Girafarig", icon: "girafarig", baseId: 203, form: "" },
  204: { name: "Pineco", icon: "pineco", baseId: 204, form: "" },
  205: { name: "Forretress", icon: "forretress", baseId: 205, form: "" },
  206: { name: "Dunsparce", icon: "dunsparce", baseId: 206, form: "" },
  207: { name: "Gligar", icon: "gligar", baseId: 207, form: "" },
  208: { name: "Steelix", icon: "steelix", baseId: 208, form: "" },
  209: { name: "Snubbull", icon: "snubbull", baseId: 209, form: "" },
  210: { name: "Granbull", icon: "granbull", baseId: 210, form: "" },
  211: { name: "Qwilfish", icon: "qwilfish", baseId: 211, form: "" },
  212: { name: "Scizor", icon: "scizor", baseId: 212, form: "" },
  213: { name: "Shuckle", icon: "shuckle", baseId: 213, form: "" },
  214: { name: "Heracross", icon: "heracross", baseId: 214, form: "" },
  215: { name: "Sneasel", icon: "sneasel", baseId: 215, form: "" },
  216: { name: "Teddiursa", icon: "teddiursa", baseId: 216, form: "" },
  217: { name: "Ursaring", icon: "ursaring", baseId: 217, form: "" },
  218: { name: "Slugma", icon: "slugma", baseId: 218, form: "" },
  219: { name: "Magcargo", icon: "magcargo", baseId: 219, form: "" },
  220: { name: "Swinub", icon: "swinub", baseId: 220, form: "" },
  221: { name: "Piloswine", icon: "piloswine", baseId: 221, form: "" },
  222: { name: "Corsola", icon: "corsola", baseId: 222, form: "" },
  223: { name: "Remoraid", icon: "remoraid", baseId: 223, form: "" },
  224: { name: "Octillery", icon: "octillery", baseId: 224, form: "" },
  225: { name: "Delibird", icon: "delibird", baseId: 225, form: "" },
  226: { name: "Mantine", icon: "mantine", baseId: 226, form: "" },
  227: { name: "Skarmory", icon: "skarmory", baseId: 227, form: "" },
  228: { name: "Houndour", icon: "houndour", baseId: 228, form: "" },
  229: { name: "Houndoom", icon: "houndoom", baseId: 229, form: "" },
  230: { name: "Kingdra", icon: "kingdra", baseId: 230, form: "" },
  231: { name: "Phanpy", icon: "phanpy", baseId: 231, form: "" },
  232: { name: "Donphan", icon: "donphan", baseId: 232, form: "" },
  233: { name: "Porygon2", icon: "porygon2", baseId: 233, form: "" },
  234: { name: "Stantler", icon: "stantler", baseId: 234, form: "" },
  235: { name: "Smeargle", icon: "smeargle", baseId: 235, form: "" },
  236: { name: "Tyrogue", icon: "tyrogue", baseId: 236, form: "" },
  237: { name: "Hitmontop", icon: "hitmontop", baseId: 237, form: "" },
  238: { name: "Smoochum", icon: "smoochum", baseId: 238, form: "" },
  239: { name: "Elekid", icon: "elekid", baseId: 239, form: "" },
  240: { name: "Magby", icon: "magby", baseId: 240, form: "" },
  241: { name: "Miltank", icon: "miltank", baseId: 241, form: "" },
  242: { name: "Blissey", icon: "blissey", baseId: 242, form: "" },
  243: { name: "Raikou", icon: "raikou", baseId: 243, form: "" },
  244: { name: "Entei", icon: "entei", baseId: 244, form: "" },
  245: { name: "Suicune", icon: "suicune", baseId: 245, form: "" },
  246: { name: "Larvitar", icon: "larvitar", baseId: 246, form: "" },
  247: { name: "Pupitar", icon: "pupitar", baseId: 247, form: "" },
  248: { name: "Tyranitar", icon: "tyranitar", baseId: 248, form: "" },
  249: { name: "Lugia", icon: "lugia", baseId: 249, form: "" },
  250: { name: "Ho-Oh", icon: "ho-oh", baseId: 250, form: "" },
  251: { name: "Celebi", icon: "celebi", baseId: 251, form: "" },
  252: { name: "Treecko", icon: "treecko", baseId: 252, form: "" },
  253: { name: "Grovyle", icon: "grovyle", baseId: 253, form: "" },
  254: { name: "Sceptile", icon: "sceptile", baseId: 254, form: "" },
  255: { name: "Torchic", icon: "torchic", baseId: 255, form: "" },
  256: { name: "Combusken", icon: "combusken", baseId: 256, form: "" },
  257: { name: "Blaziken", icon: "blaziken", baseId: 257, form: "" },
  258: { name: "Mudkip", icon: "mudkip", baseId: 258, form: "" },
  259: { name: "Marshtomp", icon: "marshtomp", baseId: 259, form: "" },
  260: { name: "Swampert", icon: "swampert", baseId: 260, form: "" },
  261: { name: "Poochyena", icon: "poochyena", baseId: 261, form: "" },
  262: { name: "Mightyena", icon: "mightyena", baseId: 262, form: "" },
  263: { name: "Zigzagoon", icon: "zigzagoon", baseId: 263, form: "" },
  264: { name: "Linoone", icon: "linoone", baseId: 264, form: "" },
  265: { name: "Wurmple", icon: "wurmple", baseId: 265, form: "" },
  266: { name: "Silcoon", icon: "silcoon", baseId: 266, form: "" },
  267: { name: "Beautifly", icon: "beautifly", baseId: 267, form: "" },
  268: { name: "Cascoon", icon: "cascoon", baseId: 268, form: "" },
  269: { name: "Dustox", icon: "dustox", baseId: 269, form: "" },
  270: { name: "Lotad", icon: "lotad", baseId: 270, form: "" },
  271: { name: "Lombre", icon: "lombre", baseId: 271, form: "" },
  272: { name: "Ludicolo", icon: "ludicolo", baseId: 272, form: "" },
  273: { name: "Seedot", icon: "seedot", baseId: 273, form: "" },
  274: { name: "Nuzleaf", icon: "nuzleaf", baseId: 274, form: "" },
  275: { name: "Shiftry", icon: "shiftry", baseId: 275, form: "" },
  276: { name: "Taillow", icon: "taillow", baseId: 276, form: "" },
  277: { name: "Swellow", icon: "swellow", baseId: 277, form: "" },
  278: { name: "Wingull", icon: "wingull", baseId: 278, form: "" },
  279: { name: "Pelipper", icon: "pelipper", baseId: 279, form: "" },
  280: { name: "Ralts", icon: "ralts", baseId: 280, form: "" },
  281: { name: "Kirlia", icon: "kirlia", baseId: 281, form: "" },
  282: { name: "Gardevoir", icon: "gardevoir", baseId: 282, form: "" },
  283: { name: "Surskit", icon: "surskit", baseId: 283, form: "" },
  284: { name: "Masquerain", icon: "masquerain", baseId: 284, form: "" },
  285: { name: "Shroomish", icon: "shroomish", baseId: 285, form: "" },
  286: { name: "Breloom", icon: "breloom", baseId: 286, form: "" },
  287: { name: "Slakoth", icon: "slakoth", baseId: 287, form: "" },
  288: { name: "Vigoroth", icon: "vigoroth", baseId: 288, form: "" },
  289: { name: "Slaking", icon: "slaking", baseId: 289, form: "" },
  290: { name: "Nincada", icon: "nincada", baseId: 290, form: "" },
  291: { name: "Ninjask", icon: "ninjask", baseId: 291, form: "" },
  292: { name: "Shedinja", icon: "shedinja", baseId: 292, form: "" },
  293: { name: "Whismur", icon: "whismur", baseId: 293, form: "" },
  294: { name: "Loudred", icon: "loudred", baseId: 294, form: "" },
  295: { name: "Exploud", icon: "exploud", baseId: 295, form: "" },
  296: { name: "Makuhita", icon: "makuhita", baseId: 296, form: "" },
  297: { name: "Hariyama", icon: "hariyama", baseId: 297, form: "" },
  298: { name: "Azurill", icon: "azurill", baseId: 298, form: "" },
  299: { name: "Nosepass", icon: "nosepass", baseId: 299, form: "" },
  300: { name: "Skitty", icon: "skitty", baseId: 300, form: "" },
  301: { name: "Delcatty", icon: "delcatty", baseId: 301, form: "" },
  302: { name: "Sableye", icon: "sableye", baseId: 302, form: "" },
  303: { name: "Mawile", icon: "mawile", baseId: 303, form: "" },
  304: { name: "Aron", icon: "aron", baseId: 304, form: "" },
  305: { name: "Lairon", icon: "lairon", baseId: 305, form: "" },
  306: { name: "Aggron", icon: "aggron", baseId: 306, form: "" },
  307: { name: "Meditite", icon: "meditite", baseId: 307, form: "" },
  308: { name: "Medicham", icon: "medicham", baseId: 308, form: "" },
  309: { name: "Electrike", icon: "electrike", baseId: 309, form: "" },
  310: { name: "Manectric", icon: "manectric", baseId: 310, form: "" },
  311: { name: "Plusle", icon: "plusle", baseId: 311, form: "" },
  312: { name: "Minun", icon: "minun", baseId: 312, form: "" },
  313: { name: "Volbeat", icon: "volbeat", baseId: 313, form: "" },
  314: { name: "Illumise", icon: "illumise", baseId: 314, form: "" },
  315: { name: "Roselia", icon: "roselia", baseId: 315, form: "" },
  316: { name: "Gulpin", icon: "gulpin", baseId: 316, form: "" },
  317: { name: "Swalot", icon: "swalot", baseId: 317, form: "" },
  318: { name: "Carvanha", icon: "carvanha", baseId: 318, form: "" },
  319: { name: "Sharpedo", icon: "sharpedo", baseId: 319, form: "" },
  320: { name: "Wailmer", icon: "wailmer", baseId: 320, form: "" },
  321: { name: "Wailord", icon: "wailord", baseId: 321, form: "" },
  322: { name: "Numel", icon: "numel", baseId: 322, form: "" },
  323: { name: "Camerupt", icon: "camerupt", baseId: 323, form: "" },
  324: { name: "Torkoal", icon: "torkoal", baseId: 324, form: "" },
  325: { name: "Spoink", icon: "spoink", baseId: 325, form: "" },
  326: { name: "Grumpig", icon: "grumpig", baseId: 326, form: "" },
  327: { name: "Spinda", icon: "spinda", baseId: 327, form: "" },
  328: { name: "Trapinch", icon: "trapinch", baseId: 328, form: "" },
  329: { name: "Vibrava", icon: "vibrava", baseId: 329, form: "" },
  330: { name: "Flygon", icon: "flygon", baseId: 330, form: "" },
  331: { name: "Cacnea", icon: "cacnea", baseId: 331, form: "" },
  332: { name: "Cacturne", icon: "cacturne", baseId: 332, form: "" },
  333: { name: "Swablu", icon: "swablu", baseId: 333, form: "" },
  334: { name: "Altaria", icon: "altaria", baseId: 334, form: "" },
  335: { name: "Zangoose", icon: "zangoose", baseId: 335, form: "" },
  336: { name: "Seviper", icon: "seviper", baseId: 336, form: "" },
  337: { name: "Lunatone", icon: "lunatone", baseId: 337, form: "" },
  338: { name: "Solrock", icon: "solrock", baseId: 338, form: "" },
  339: { name: "Barboach", icon: "barboach", baseId: 339, form: "" },
  340: { name: "Whiscash", icon: "whiscash", baseId: 340, form: "" },
  341: { name: "Corphish", icon: "corphish", baseId: 341, form: "" },
  342: { name: "Crawdaunt", icon: "crawdaunt", baseId: 342, form: "" },
  343: { name: "Baltoy", icon: "baltoy", baseId: 343, form: "" },
  344: { name: "Claydol", icon: "claydol", baseId: 344, form: "" },
  345: { name: "Lileep", icon: "lileep", baseId: 345, form: "" },
  346: { name: "Cradily", icon: "cradily", baseId: 346, form: "" },
  347: { name: "Anorith", icon: "anorith", baseId: 347, form: "" },
  348: { name: "Armaldo", icon: "armaldo", baseId: 348, form: "" },
  349: { name: "Feebas", icon: "feebas", baseId: 349, form: "" },
  350: { name: "Milotic", icon: "milotic", baseId: 350, form: "" },
  351: { name: "Castform-Normal", icon: "castform", baseId: 351, form: "Normal" },
  352: { name: "Kecleon", icon: "kecleon", baseId: 352, form: "" },
  353: { name: "Shuppet", icon: "shuppet", baseId: 353, form: "" },
  354: { name: "Banette", icon: "banette", baseId: 354, form: "" },
  355: { name: "Duskull", icon: "duskull", baseId: 355, form: "" },
  356: { name: "Dusclops", icon: "dusclops", baseId: 356, form: "" },
  357: { name: "Tropius", icon: "tropius", baseId: 357, form: "" },
  358: { name: "Chimecho", icon: "chimecho", baseId: 358, form: "" },
  359: { name: "Absol", icon: "absol", baseId: 359, form: "" },
  360: { name: "Wynaut", icon: "wynaut", baseId: 360, form: "" },
  361: { name: "Snorunt", icon: "snorunt", baseId: 361, form: "" },
  362: { name: "Glalie", icon: "glalie", baseId: 362, form: "" },
  363: { name: "Spheal", icon: "spheal", baseId: 363, form: "" },
  364: { name: "Sealeo", icon: "sealeo", baseId: 364, form: "" },
  365: { name: "Walrein", icon: "walrein", baseId: 365, form: "" },
  366: { name: "Clamperl", icon: "clamperl", baseId: 366, form: "" },
  367: { name: "Huntail", icon: "huntail", baseId: 367, form: "" },
  368: { name: "Gorebyss", icon: "gorebyss", baseId: 368, form: "" },
  369: { name: "Relicanth", icon: "relicanth", baseId: 369, form: "" },
  370: { name: "Luvdisc", icon: "luvdisc", baseId: 370, form: "" },
  371: { name: "Bagon", icon: "bagon", baseId: 371, form: "" },
  372: { name: "Shelgon", icon: "shelgon", baseId: 372, form: "" },
  373: { name: "Salamence", icon: "salamence", baseId: 373, form: "" },
  374: { name: "Beldum", icon: "beldum", baseId: 374, form: "" },
  375: { name: "Metang", icon: "metang", baseId: 375, form: "" },
  376: { name: "Metagross", icon: "metagross", baseId: 376, form: "" },
  377: { name: "Regirock", icon: "regirock", baseId: 377, form: "" },
  378: { name: "Regice", icon: "regice", baseId: 378, form: "" },
  379: { name: "Registeel", icon: "registeel", baseId: 379, form: "" },
  380: { name: "Latias", icon: "latias", baseId: 380, form: "" },
  381: { name: "Latios", icon: "latios", baseId: 381, form: "" },
  382: { name: "Kyogre", icon: "kyogre", baseId: 382, form: "" },
  383: { name: "Groudon", icon: "groudon", baseId: 383, form: "" },
  384: { name: "Rayquaza", icon: "rayquaza", baseId: 384, form: "" },
  385: { name: "Jirachi", icon: "jirachi", baseId: 385, form: "" },
  386: { name: "Deoxys-Normal", icon: "deoxys", baseId: 386, form: "Normal" },
  387: { name: "Turtwig", icon: "turtwig", baseId: 387, form: "" },
  388: { name: "Grotle", icon: "grotle", baseId: 388, form: "" },
  389: { name: "Torterra", icon: "torterra", baseId: 389, form: "" },
  390: { name: "Chimchar", icon: "chimchar", baseId: 390, form: "" },
  391: { name: "Monferno", icon: "monferno", baseId: 391, form: "" },
  392: { name: "Infernape", icon: "infernape", baseId: 392, form: "" },
  393: { name: "Piplup", icon: "piplup", baseId: 393, form: "" },
  394: { name: "Prinplup", icon: "prinplup", baseId: 394, form: "" },
  395: { name: "Empoleon", icon: "empoleon", baseId: 395, form: "" },
  396: { name: "Starly", icon: "starly", baseId: 396, form: "" },
  397: { name: "Staravia", icon: "staravia", baseId: 397, form: "" },
  398: { name: "Staraptor", icon: "staraptor", baseId: 398, form: "" },
  399: { name: "Bidoof", icon: "bidoof", baseId: 399, form: "" },
  400: { name: "Bibarel", icon: "bibarel", baseId: 400, form: "" },
  401: { name: "Kricketot", icon: "kricketot", baseId: 401, form: "" },
  402: { name: "Kricketune", icon: "kricketune", baseId: 402, form: "" },
  403: { name: "Shinx", icon: "shinx", baseId: 403, form: "" },
  404: { name: "Luxio", icon: "luxio", baseId: 404, form: "" },
  405: { name: "Luxray", icon: "luxray", baseId: 405, form: "" },
  406: { name: "Budew", icon: "budew", baseId: 406, form: "" },
  407: { name: "Roserade", icon: "roserade", baseId: 407, form: "" },
  408: { name: "Cranidos", icon: "cranidos", baseId: 408, form: "" },
  409: { name: "Rampardos", icon: "rampardos", baseId: 409, form: "" },
  410: { name: "Shieldon", icon: "shieldon", baseId: 410, form: "" },
  411: { name: "Bastiodon", icon: "bastiodon", baseId: 411, form: "" },
  412: { name: "Burmy-Plant", icon: "burmy", baseId: 412, form: "Plant" },
  413: { name: "Wormadam-Plant", icon: "wormadam-plant", baseId: 413, form: "Plant" },
  414: { name: "Mothim-Plant", icon: "mothim", baseId: 414, form: "Plant" },
  415: { name: "Combee", icon: "combee", baseId: 415, form: "" },
  416: { name: "Vespiquen", icon: "vespiquen", baseId: 416, form: "" },
  417: { name: "Pachirisu", icon: "pachirisu", baseId: 417, form: "" },
  418: { name: "Buizel", icon: "buizel", baseId: 418, form: "" },
  419: { name: "Floatzel", icon: "floatzel", baseId: 419, form: "" },
  420: { name: "Cherubi", icon: "cherubi", baseId: 420, form: "" },
  421: { name: "Cherrim-Overcast", icon: "cherrim", baseId: 421, form: "Overcast" },
  422: { name: "Shellos-West", icon: "shellos", baseId: 422, form: "West" },
  423: { name: "Gastrodon-West", icon: "gastrodon", baseId: 423, form: "West" },
  424: { name: "Ambipom", icon: "ambipom", baseId: 424, form: "" },
  425: { name: "Drifloon", icon: "drifloon", baseId: 425, form: "" },
  426: { name: "Drifblim", icon: "drifblim", baseId: 426, form: "" },
  427: { name: "Buneary", icon: "buneary", baseId: 427, form: "" },
  428: { name: "Lopunny", icon: "lopunny", baseId: 428, form: "" },
  429: { name: "Mismagius", icon: "mismagius", baseId: 429, form: "" },
  430: { name: "Honchkrow", icon: "honchkrow", baseId: 430, form: "" },
  431: { name: "Glameow", icon: "glameow", baseId: 431, form: "" },
  432: { name: "Purugly", icon: "purugly", baseId: 432, form: "" },
  433: { name: "Chingling", icon: "chingling", baseId: 433, form: "" },
  434: { name: "Stunky", icon: "stunky", baseId: 434, form: "" },
  435: { name: "Skuntank", icon: "skuntank", baseId: 435, form: "" },
  436: { name: "Bronzor", icon: "bronzor", baseId: 436, form: "" },
  437: { name: "Bronzong", icon: "bronzong", baseId: 437, form: "" },
  438: { name: "Bonsly", icon: "bonsly", baseId: 438, form: "" },
  439: { name: "Mime Jr.", icon: "mime-jr", baseId: 439, form: "" },
  440: { name: "Happiny", icon: "happiny", baseId: 440, form: "" },
  441: { name: "Chatot", icon: "chatot", baseId: 441, form: "" },
  442: { name: "Spiritomb", icon: "spiritomb", baseId: 442, form: "" },
  443: { name: "Gible", icon: "gible", baseId: 443, form: "" },
  444: { name: "Gabite", icon: "gabite", baseId: 444, form: "" },
  445: { name: "Garchomp", icon: "garchomp", baseId: 445, form: "" },
  446: { name: "Munchlax", icon: "munchlax", baseId: 446, form: "" },
  447: { name: "Riolu", icon: "riolu", baseId: 447, form: "" },
  448: { name: "Lucario", icon: "lucario", baseId: 448, form: "" },
  449: { name: "Hippopotas", icon: "hippopotas", baseId: 449, form: "" },
  450: { name: "Hippowdon", icon: "hippowdon", baseId: 450, form: "" },
  451: { name: "Skorupi", icon: "skorupi", baseId: 451, form: "" },
  452: { name: "Drapion", icon: "drapion", baseId: 452, form: "" },
  453: { name: "Croagunk", icon: "croagunk", baseId: 453, form: "" },
  454: { name: "Toxicroak", icon: "toxicroak", baseId: 454, form: "" },
  455: { name: "Carnivine", icon: "carnivine", baseId: 455, form: "" },
  456: { name: "Finneon", icon: "finneon", baseId: 456, form: "" },
  457: { name: "Lumineon", icon: "lumineon", baseId: 457, form: "" },
  458: { name: "Mantyke", icon: "mantyke", baseId: 458, form: "" },
  459: { name: "Snover", icon: "snover", baseId: 459, form: "" },
  460: { name: "Abomasnow", icon: "abomasnow", baseId: 460, form: "" },
  461: { name: "Weavile", icon: "weavile", baseId: 461, form: "" },
  462: { name: "Magnezone", icon: "magnezone", baseId: 462, form: "" },
  463: { name: "Lickilicky", icon: "lickilicky", baseId: 463, form: "" },
  464: { name: "Rhyperior", icon: "rhyperior", baseId: 464, form: "" },
  465: { name: "Tangrowth", icon: "tangrowth", baseId: 465, form: "" },
  466: { name: "Electivire", icon: "electivire", baseId: 466, form: "" },
  467: { name: "Magmortar", icon: "magmortar", baseId: 467, form: "" },
  468: { name: "Togekiss", icon: "togekiss", baseId: 468, form: "" },
  469: { name: "Yanmega", icon: "yanmega", baseId: 469, form: "" },
  470: { name: "Leafeon", icon: "leafeon", baseId: 470, form: "" },
  471: { name: "Glaceon", icon: "glaceon", baseId: 471, form: "" },
  472: { name: "Gliscor", icon: "gliscor", baseId: 472, form: "" },
  473: { name: "Mamoswine", icon: "mamoswine", baseId: 473, form: "" },
  474: { name: "Porygon-Z", icon: "porygon-z", baseId: 137, form: "Z" },
  475: { name: "Gallade", icon: "gallade", baseId: 475, form: "" },
  476: { name: "Probopass", icon: "probopass", baseId: 476, form: "" },
  477: { name: "Dusknoir", icon: "dusknoir", baseId: 477, form: "" },
  478: { name: "Froslass", icon: "froslass", baseId: 478, form: "" },
  479: { name: "Rotom", icon: "rotom", baseId: 479, form: "" },
  480: { name: "Uxie", icon: "uxie", baseId: 480, form: "" },
  481: { name: "Mesprit", icon: "mesprit", baseId: 481, form: "" },
  482: { name: "Azelf", icon: "azelf", baseId: 482, form: "" },
  483: { name: "Dialga", icon: "dialga", baseId: 483, form: "" },
  484: { name: "Palkia", icon: "palkia", baseId: 484, form: "" },
  485: { name: "Heatran", icon: "heatran", baseId: 485, form: "" },
  486: { name: "Regigigas", icon: "regigigas", baseId: 486, form: "" },
  487: { name: "Giratina-Altered", icon: "giratina", baseId: 487, form: "Altered" },
  488: { name: "Cresselia", icon: "cresselia", baseId: 488, form: "" },
  489: { name: "Phione", icon: "phione", baseId: 489, form: "" },
  490: { name: "Manaphy", icon: "manaphy", baseId: 490, form: "" },
  491: { name: "Darkrai", icon: "darkrai", baseId: 491, form: "" },
  492: { name: "Shaymin-Land", icon: "shaymin", baseId: 492, form: "Land" },
  493: { name: "Arceus-Normal", icon: "arceus", baseId: 493, form: "Normal" },
  494: { name: "Victini", icon: "victini", baseId: 494, form: "" },
  495: { name: "Snivy", icon: "snivy", baseId: 495, form: "" },
  496: { name: "Servine", icon: "servine", baseId: 496, form: "" },
  497: { name: "Serperior", icon: "serperior", baseId: 497, form: "" },
  498: { name: "Tepig", icon: "tepig", baseId: 498, form: "" },
  499: { name: "Pignite", icon: "pignite", baseId: 499, form: "" },
  500: { name: "Emboar", icon: "emboar", baseId: 500, form: "" },
  501: { name: "Oshawott", icon: "oshawott", baseId: 501, form: "" },
  502: { name: "Dewott", icon: "dewott", baseId: 502, form: "" },
  503: { name: "Samurott", icon: "samurott", baseId: 503, form: "" },
  504: { name: "Patrat", icon: "patrat", baseId: 504, form: "" },
  505: { name: "Watchog", icon: "watchog", baseId: 505, form: "" },
  506: { name: "Lillipup", icon: "lillipup", baseId: 506, form: "" },
  507: { name: "Herdier", icon: "herdier", baseId: 507, form: "" },
  508: { name: "Stoutland", icon: "stoutland", baseId: 508, form: "" },
  509: { name: "Purrloin", icon: "purrloin", baseId: 509, form: "" },
  510: { name: "Liepard", icon: "liepard", baseId: 510, form: "" },
  511: { name: "Pansage", icon: "pansage", baseId: 511, form: "" },
  512: { name: "Simisage", icon: "simisage", baseId: 512, form: "" },
  513: { name: "Pansear", icon: "pansear", baseId: 513, form: "" },
  514: { name: "Simisear", icon: "simisear", baseId: 514, form: "" },
  515: { name: "Panpour", icon: "panpour", baseId: 515, form: "" },
  516: { name: "Simipour", icon: "simipour", baseId: 516, form: "" },
  517: { name: "Munna", icon: "munna", baseId: 517, form: "" },
  518: { name: "Musharna", icon: "musharna", baseId: 518, form: "" },
  519: { name: "Pidove", icon: "pidove", baseId: 519, form: "" },
  520: { name: "Tranquill", icon: "tranquill", baseId: 520, form: "" },
  521: { name: "Unfezant", icon: "unfezant", baseId: 521, form: "" },
  522: { name: "Blitzle", icon: "blitzle", baseId: 522, form: "" },
  523: { name: "Zebstrika", icon: "zebstrika", baseId: 523, form: "" },
  524: { name: "Roggenrola", icon: "roggenrola", baseId: 524, form: "" },
  525: { name: "Boldore", icon: "boldore", baseId: 525, form: "" },
  526: { name: "Gigalith", icon: "gigalith", baseId: 526, form: "" },
  527: { name: "Woobat", icon: "woobat", baseId: 527, form: "" },
  528: { name: "Swoobat", icon: "swoobat", baseId: 528, form: "" },
  529: { name: "Drilbur", icon: "drilbur", baseId: 529, form: "" },
  530: { name: "Excadrill", icon: "excadrill", baseId: 530, form: "" },
  531: { name: "Audino", icon: "audino", baseId: 531, form: "" },
  532: { name: "Timburr", icon: "timburr", baseId: 532, form: "" },
  533: { name: "Gurdurr", icon: "gurdurr", baseId: 533, form: "" },
  534: { name: "Conkeldurr", icon: "conkeldurr", baseId: 534, form: "" },
  535: { name: "Tympole", icon: "tympole", baseId: 535, form: "" },
  536: { name: "Palpitoad", icon: "palpitoad", baseId: 536, form: "" },
  537: { name: "Seismitoad", icon: "seismitoad", baseId: 537, form: "" },
  538: { name: "Throh", icon: "throh", baseId: 538, form: "" },
  539: { name: "Sawk", icon: "sawk", baseId: 539, form: "" },
  540: { name: "Sewaddle", icon: "sewaddle", baseId: 540, form: "" },
  541: { name: "Swadloon", icon: "swadloon", baseId: 541, form: "" },
  542: { name: "Leavanny", icon: "leavanny", baseId: 542, form: "" },
  543: { name: "Venipede", icon: "venipede", baseId: 543, form: "" },
  544: { name: "Whirlipede", icon: "whirlipede", baseId: 544, form: "" },
  545: { name: "Scolipede", icon: "scolipede", baseId: 545, form: "" },
  546: { name: "Cottonee", icon: "cottonee", baseId: 546, form: "" },
  547: { name: "Whimsicott", icon: "whimsicott", baseId: 547, form: "" },
  548: { name: "Petilil", icon: "petilil", baseId: 548, form: "" },
  549: { name: "Lilligant", icon: "lilligant", baseId: 549, form: "" },
  550: { name: "Basculin-Red-Striped", icon: "basculin", baseId: 550, form: "Red Striped" },
  551: { name: "Sandile", icon: "sandile", baseId: 551, form: "" },
  552: { name: "Krokorok", icon: "krokorok", baseId: 552, form: "" },
  553: { name: "Krookodile", icon: "krookodile", baseId: 553, form: "" },
  554: { name: "Darumaka", icon: "darumaka", baseId: 554, form: "" },
  555: { name: "Darmanitan-Standard", icon: "darmanitan", baseId: 555, form: "Standard" },
  556: { name: "Maractus", icon: "maractus", baseId: 556, form: "" },
  557: { name: "Dwebble", icon: "dwebble", baseId: 557, form: "" },
  558: { name: "Crustle", icon: "crustle", baseId: 558, form: "" },
  559: { name: "Scraggy", icon: "scraggy", baseId: 559, form: "" },
  560: { name: "Scrafty", icon: "scrafty", baseId: 560, form: "" },
  561: { name: "Sigilyph", icon: "sigilyph", baseId: 561, form: "" },
  562: { name: "Yamask", icon: "yamask", baseId: 562, form: "" },
  563: { name: "Cofagrigus", icon: "cofagrigus", baseId: 563, form: "" },
  564: { name: "Tirtouga", icon: "tirtouga", baseId: 564, form: "" },
  565: { name: "Carracosta", icon: "carracosta", baseId: 565, form: "" },
  566: { name: "Archen", icon: "archen", baseId: 566, form: "" },
  567: { name: "Archeops", icon: "archeops", baseId: 567, form: "" },
  568: { name: "Trubbish", icon: "trubbish", baseId: 568, form: "" },
  569: { name: "Garbodor", icon: "garbodor", baseId: 569, form: "" },
  570: { name: "Zorua", icon: "zorua", baseId: 570, form: "" },
  571: { name: "Zoroark", icon: "zoroark", baseId: 571, form: "" },
  572: { name: "Minccino", icon: "minccino", baseId: 572, form: "" },
  573: { name: "Cinccino", icon: "cinccino", baseId: 573, form: "" },
  574: { name: "Gothita", icon: "gothita", baseId: 574, form: "" },
  575: { name: "Gothorita", icon: "gothorita", baseId: 575, form: "" },
  576: { name: "Gothitelle", icon: "gothitelle", baseId: 576, form: "" },
  577: { name: "Solosis", icon: "solosis", baseId: 577, form: "" },
  578: { name: "Duosion", icon: "duosion", baseId: 578, form: "" },
  579: { name: "Reuniclus", icon: "reuniclus", baseId: 579, form: "" },
  580: { name: "Ducklett", icon: "ducklett", baseId: 580, form: "" },
  581: { name: "Swanna", icon: "swanna", baseId: 581, form: "" },
  582: { name: "Vanillite", icon: "vanillite", baseId: 582, form: "" },
  583: { name: "Vanillish", icon: "vanillish", baseId: 583, form: "" },
  584: { name: "Vanilluxe", icon: "vanilluxe", baseId: 584, form: "" },
  585: { name: "Deerling-Spring", icon: "deerling", baseId: 585, form: "Spring" },
  586: { name: "Sawsbuck-Spring", icon: "sawsbuck", baseId: 586, form: "Spring" },
  587: { name: "Emolga", icon: "emolga", baseId: 587, form: "" },
  588: { name: "Karrablast", icon: "karrablast", baseId: 588, form: "" },
  589: { name: "Escavalier", icon: "escavalier", baseId: 589, form: "" },
  590: { name: "Foongus", icon: "foongus", baseId: 590, form: "" },
  591: { name: "Amoonguss", icon: "amoonguss", baseId: 591, form: "" },
  592: { name: "Frillish", icon: "frillish", baseId: 592, form: "" },
  593: { name: "Jellicent", icon: "jellicent", baseId: 593, form: "" },
  594: { name: "Alomomola", icon: "alomomola", baseId: 594, form: "" },
  595: { name: "Joltik", icon: "joltik", baseId: 595, form: "" },
  596: { name: "Galvantula", icon: "galvantula", baseId: 596, form: "" },
  597: { name: "Ferroseed", icon: "ferroseed", baseId: 597, form: "" },
  598: { name: "Ferrothorn", icon: "ferrothorn", baseId: 598, form: "" },
  599: { name: "Klink", icon: "klink", baseId: 599, form: "" },
  600: { name: "Klang", icon: "klang", baseId: 600, form: "" },
  601: { name: "Klinklang", icon: "klinklang", baseId: 601, form: "" },
  602: { name: "Tynamo", icon: "tynamo", baseId: 602, form: "" },
  603: { name: "Eelektrik", icon: "eelektrik", baseId: 603, form: "" },
  604: { name: "Eelektross", icon: "eelektross", baseId: 604, form: "" },
  605: { name: "Elgyem", icon: "elgyem", baseId: 605, form: "" },
  606: { name: "Beheeyem", icon: "beheeyem", baseId: 606, form: "" },
  607: { name: "Litwick", icon: "litwick", baseId: 607, form: "" },
  608: { name: "Lampent", icon: "lampent", baseId: 608, form: "" },
  609: { name: "Chandelure", icon: "chandelure", baseId: 609, form: "" },
  610: { name: "Axew", icon: "axew", baseId: 610, form: "" },
  611: { name: "Fraxure", icon: "fraxure", baseId: 611, form: "" },
  612: { name: "Haxorus", icon: "haxorus", baseId: 612, form: "" },
  613: { name: "Cubchoo", icon: "cubchoo", baseId: 613, form: "" },
  614: { name: "Beartic", icon: "beartic", baseId: 614, form: "" },
  615: { name: "Cryogonal", icon: "cryogonal", baseId: 615, form: "" },
  616: { name: "Shelmet", icon: "shelmet", baseId: 616, form: "" },
  617: { name: "Accelgor", icon: "accelgor", baseId: 617, form: "" },
  618: { name: "Stunfisk", icon: "stunfisk", baseId: 618, form: "" },
  619: { name: "Mienfoo", icon: "mienfoo", baseId: 619, form: "" },
  620: { name: "Mienshao", icon: "mienshao", baseId: 620, form: "" },
  621: { name: "Druddigon", icon: "druddigon", baseId: 621, form: "" },
  622: { name: "Golett", icon: "golett", baseId: 622, form: "" },
  623: { name: "Golurk", icon: "golurk", baseId: 623, form: "" },
  624: { name: "Pawniard", icon: "pawniard", baseId: 624, form: "" },
  625: { name: "Bisharp", icon: "bisharp", baseId: 625, form: "" },
  626: { name: "Bouffalant", icon: "bouffalant", baseId: 626, form: "" },
  627: { name: "Rufflet", icon: "rufflet", baseId: 627, form: "" },
  628: { name: "Braviary", icon: "braviary", baseId: 628, form: "" },
  629: { name: "Vullaby", icon: "vullaby", baseId: 629, form: "" },
  630: { name: "Mandibuzz", icon: "mandibuzz", baseId: 630, form: "" },
  631: { name: "Heatmor", icon: "heatmor", baseId: 631, form: "" },
  632: { name: "Durant", icon: "durant", baseId: 632, form: "" },
  633: { name: "Deino", icon: "deino", baseId: 633, form: "" },
  634: { name: "Zweilous", icon: "zweilous", baseId: 634, form: "" },
  635: { name: "Hydreigon", icon: "hydreigon", baseId: 635, form: "" },
  636: { name: "Larvesta", icon: "larvesta", baseId: 636, form: "" },
  637: { name: "Volcarona", icon: "volcarona", baseId: 637, form: "" },
  638: { name: "Cobalion", icon: "cobalion", baseId: 638, form: "" },
  639: { name: "Terrakion", icon: "terrakion", baseId: 639, form: "" },
  640: { name: "Virizion", icon: "virizion", baseId: 640, form: "" },
  641: { name: "Tornadus-Incarnate", icon: "tornadus", baseId: 641, form: "Incarnate" },
  642: { name: "Thundurus-Incarnate", icon: "thundurus", baseId: 642, form: "Incarnate" },
  643: { name: "Reshiram", icon: "reshiram", baseId: 643, form: "" },
  644: { name: "Zekrom", icon: "zekrom", baseId: 644, form: "" },
  645: { name: "Landorus-Incarnate", icon: "landorus", baseId: 645, form: "Incarnate" },
  646: { name: "Kyurem", icon: "kyurem", baseId: 646, form: "" },
  647: { name: "Keldeo-Ordinary", icon: "keldeo", baseId: 647, form: "Ordinary" },
  648: { name: "Meloetta-Aria", icon: "meloetta", baseId: 648, form: "Aria" },
  649: { name: "Genesect", icon: "genesect", baseId: 649, form: "" },
  650: { name: "Chespin", icon: "chespin", baseId: 650, form: "" },
  651: { name: "Quilladin", icon: "quilladin", baseId: 651, form: "" },
  652: { name: "Chesnaught", icon: "chesnaught", baseId: 652, form: "" },
  653: { name: "Fennekin", icon: "fennekin", baseId: 653, form: "" },
  654: { name: "Braixen", icon: "braixen", baseId: 654, form: "" },
  655: { name: "Delphox", icon: "delphox", baseId: 655, form: "" },
  656: { name: "Froakie", icon: "froakie", baseId: 656, form: "" },
  657: { name: "Frogadier", icon: "frogadier", baseId: 657, form: "" },
  658: { name: "Greninja", icon: "greninja", baseId: 658, form: "" },
  659: { name: "Bunnelby", icon: "bunnelby", baseId: 659, form: "" },
  660: { name: "Diggersby", icon: "diggersby", baseId: 660, form: "" },
  661: { name: "Fletchling", icon: "fletchling", baseId: 661, form: "" },
  662: { name: "Fletchinder", icon: "fletchinder", baseId: 662, form: "" },
  663: { name: "Talonflame", icon: "talonflame", baseId: 663, form: "" },
  664: { name: "Scatterbug-Icy-Snow", icon: "scatterbug", baseId: 664, form: "Icy Snow" },
  665: { name: "Spewpa-Icy-Snow", icon: "spewpa", baseId: 665, form: "Icy Snow" },
  666: { name: "Vivillon-Icy-Snow", icon: "vivillon-icy-snow", baseId: 666, form: "Icy Snow" },
  667: { name: "Litleo", icon: "litleo", baseId: 667, form: "" },
  668: { name: "Pyroar", icon: "pyroar", baseId: 668, form: "" },
  669: { name: "Flabébé-Red", icon: "flabebe", baseId: 669, form: "Red" },
  670: { name: "Floette-Red", icon: "floette", baseId: 670, form: "Red" },
  671: { name: "Florges-Red", icon: "florges", baseId: 671, form: "Red" },
  672: { name: "Skiddo", icon: "skiddo", baseId: 672, form: "" },
  673: { name: "Gogoat", icon: "gogoat", baseId: 673, form: "" },
  674: { name: "Pancham", icon: "pancham", baseId: 674, form: "" },
  675: { name: "Pangoro", icon: "pangoro", baseId: 675, form: "" },
  676: { name: "Furfrou-Natural", icon: "furfrou", baseId: 676, form: "Natural" },
  677: { name: "Espurr", icon: "espurr", baseId: 677, form: "" },
  678: { name: "Meowstic-M", icon: "meowstic-m", baseId: 678, form: "M" },
  679: { name: "Honedge", icon: "honedge", baseId: 679, form: "" },
  680: { name: "Doublade", icon: "doublade", baseId: 680, form: "" },
  681: { name: "Aegislash-Shield", icon: "aegislash", baseId: 681, form: "Shield" },
  682: { name: "Spritzee", icon: "spritzee", baseId: 682, form: "" },
  683: { name: "Aromatisse", icon: "aromatisse", baseId: 683, form: "" },
  684: { name: "Swirlix", icon: "swirlix", baseId: 684, form: "" },
  685: { name: "Slurpuff", icon: "slurpuff", baseId: 685, form: "" },
  686: { name: "Inkay", icon: "inkay", baseId: 686, form: "" },
  687: { name: "Malamar", icon: "malamar", baseId: 687, form: "" },
  688: { name: "Binacle", icon: "binacle", baseId: 688, form: "" },
  689: { name: "Barbaracle", icon: "barbaracle", baseId: 689, form: "" },
  690: { name: "Skrelp", icon: "skrelp", baseId: 690, form: "" },
  691: { name: "Dragalge", icon: "dragalge", baseId: 691, form: "" },
  692: { name: "Clauncher", icon: "clauncher", baseId: 692, form: "" },
  693: { name: "Clawitzer", icon: "clawitzer", baseId: 693, form: "" },
  694: { name: "Helioptile", icon: "helioptile", baseId: 694, form: "" },
  695: { name: "Heliolisk", icon: "heliolisk", baseId: 695, form: "" },
  696: { name: "Tyrunt", icon: "tyrunt", baseId: 696, form: "" },
  697: { name: "Tyrantrum", icon: "tyrantrum", baseId: 697, form: "" },
  698: { name: "Amaura", icon: "amaura", baseId: 698, form: "" },
  699: { name: "Aurorus", icon: "aurorus", baseId: 699, form: "" },
  700: { name: "Sylveon", icon: "sylveon", baseId: 700, form: "" },
  701: { name: "Hawlucha", icon: "hawlucha", baseId: 701, form: "" },
  702: { name: "Dedenne", icon: "dedenne", baseId: 702, form: "" },
  703: { name: "Carbink", icon: "carbink", baseId: 703, form: "" },
  704: { name: "Goomy", icon: "goomy", baseId: 704, form: "" },
  705: { name: "Sliggoo", icon: "sliggoo", baseId: 705, form: "" },
  706: { name: "Goodra", icon: "goodra", baseId: 706, form: "" },
  707: { name: "Klefki", icon: "klefki", baseId: 707, form: "" },
  708: { name: "Phantump", icon: "phantump", baseId: 708, form: "" },
  709: { name: "Trevenant", icon: "trevenant", baseId: 709, form: "" },
  710: { name: "Pumpkaboo-Average", icon: "pumpkaboo", baseId: 710, form: "Average" },
  711: { name: "Gourgeist-Average", icon: "gourgeist", baseId: 711, form: "Average" },
  712: { name: "Bergmite", icon: "bergmite", baseId: 712, form: "" },
  713: { name: "Avalugg", icon: "avalugg", baseId: 713, form: "" },
  714: { name: "Noibat", icon: "noibat", baseId: 714, form: "" },
  715: { name: "Noivern", icon: "noivern", baseId: 715, form: "" },
  716: { name: "Xerneas-Neutral", icon: "xerneas-neutral", baseId: 716, form: "Neutral" },
  717: { name: "Yveltal", icon: "yveltal", baseId: 717, form: "" },
  718: { name: "Zygarde-50", icon: "zygarde-50", baseId: 718, form: "50" },
  719: { name: "Diancie", icon: "diancie", baseId: 719, form: "" },
  720: { name: "Hoopa-Confined", icon: "hoopa", baseId: 720, form: "Confined" },
  721: { name: "Volcanion", icon: "volcanion", baseId: 721, form: "" },
  722: { name: "Rowlet", icon: "rowlet", baseId: 722, form: "" },
  723: { name: "Dartrix", icon: "dartrix", baseId: 723, form: "" },
  724: { name: "Decidueye", icon: "decidueye", baseId: 724, form: "" },
  725: { name: "Litten", icon: "litten", baseId: 725, form: "" },
  726: { name: "Torracat", icon: "torracat", baseId: 726, form: "" },
  727: { name: "Incineroar", icon: "incineroar", baseId: 727, form: "" },
  728: { name: "Popplio", icon: "popplio", baseId: 728, form: "" },
  729: { name: "Brionne", icon: "brionne", baseId: 729, form: "" },
  730: { name: "Primarina", icon: "primarina", baseId: 730, form: "" },
  731: { name: "Pikipek", icon: "pikipek", baseId: 731, form: "" },
  732: { name: "Trumbeak", icon: "trumbeak", baseId: 732, form: "" },
  733: { name: "Toucannon", icon: "toucannon", baseId: 733, form: "" },
  734: { name: "Yungoos", icon: "yungoos", baseId: 734, form: "" },
  735: { name: "Gumshoos", icon: "gumshoos", baseId: 735, form: "" },
  736: { name: "Grubbin", icon: "grubbin", baseId: 736, form: "" },
  737: { name: "Charjabug", icon: "charjabug", baseId: 737, form: "" },
  738: { name: "Vikavolt", icon: "vikavolt", baseId: 738, form: "" },
  739: { name: "Crabrawler", icon: "crabrawler", baseId: 739, form: "" },
  740: { name: "Crabominable", icon: "crabominable", baseId: 740, form: "" },
  741: { name: "Oricorio-Baile", icon: "oricorio", baseId: 741, form: "Baile" },
  742: { name: "Cutiefly", icon: "cutiefly", baseId: 742, form: "" },
  743: { name: "Ribombee", icon: "ribombee", baseId: 743, form: "" },
  744: { name: "Rockruff", icon: "rockruff", baseId: 744, form: "" },
  745: { name: "Lycanroc-Midday", icon: "lycanroc", baseId: 745, form: "Midday" },
  746: { name: "Wishiwashi-Solo", icon: "wishiwashi", baseId: 746, form: "Solo" },
  747: { name: "Mareanie", icon: "mareanie", baseId: 747, form: "" },
  748: { name: "Toxapex", icon: "toxapex", baseId: 748, form: "" },
  749: { name: "Mudbray", icon: "mudbray", baseId: 749, form: "" },
  750: { name: "Mudsdale", icon: "mudsdale", baseId: 750, form: "" },
  751: { name: "Dewpider", icon: "dewpider", baseId: 751, form: "" },
  752: { name: "Araquanid", icon: "araquanid", baseId: 752, form: "" },
  753: { name: "Fomantis", icon: "fomantis", baseId: 753, form: "" },
  754: { name: "Lurantis", icon: "lurantis", baseId: 754, form: "" },
  755: { name: "Morelull", icon: "morelull", baseId: 755, form: "" },
  756: { name: "Shiinotic", icon: "shiinotic", baseId: 756, form: "" },
  757: { name: "Salandit", icon: "salandit", baseId: 757, form: "" },
  758: { name: "Salazzle", icon: "salazzle", baseId: 758, form: "" },
  759: { name: "Stufful", icon: "stufful", baseId: 759, form: "" },
  760: { name: "Bewear", icon: "bewear", baseId: 760, form: "" },
  761: { name: "Bounsweet", icon: "bounsweet", baseId: 761, form: "" },
  762: { name: "Steenee", icon: "steenee", baseId: 762, form: "" },
  763: { name: "Tsareena", icon: "tsareena", baseId: 763, form: "" },
  764: { name: "Comfey", icon: "comfey", baseId: 764, form: "" },
  765: { name: "Oranguru", icon: "oranguru", baseId: 765, form: "" },
  766: { name: "Passimian", icon: "passimian", baseId: 766, form: "" },
  767: { name: "Wimpod", icon: "wimpod", baseId: 767, form: "" },
  768: { name: "Golisopod", icon: "golisopod", baseId: 768, form: "" },
  769: { name: "Sandygast", icon: "sandygast", baseId: 769, form: "" },
  770: { name: "Palossand", icon: "palossand", baseId: 770, form: "" },
  771: { name: "Pyukumuku", icon: "pyukumuku", baseId: 771, form: "" },
  772: { name: "Type: Null", icon: "type-null", baseId: 772, form: "" },
  773: { name: "Silvally-Normal", icon: "silvally", baseId: 773, form: "Normal" },
  774: { name: "Minior-Meteor-Red", icon: "minior", baseId: 774, form: "Red" },
  775: { name: "Komala", icon: "komala", baseId: 775, form: "" },
  776: { name: "Turtonator", icon: "turtonator", baseId: 776, form: "" },
  777: { name: "Togedemaru", icon: "togedemaru", baseId: 777, form: "" },
  778: { name: "Mimikyu-Disguised", icon: "mimikyu", baseId: 778, form: "Disguised" },
  779: { name: "Bruxish", icon: "bruxish", baseId: 779, form: "" },
  780: { name: "Drampa", icon: "drampa", baseId: 780, form: "" },
  781: { name: "Dhelmise", icon: "dhelmise", baseId: 781, form: "" },
  782: { name: "Jangmo-o", icon: "jangmo-o", baseId: 782, form: "" },
  783: { name: "Hakamo-o", icon: "hakamo-o", baseId: 783, form: "" },
  784: { name: "Kommo-o", icon: "kommo-o", baseId: 784, form: "" },
  785: { name: "Tapu-Koko", icon: "tapu-koko", baseId: 785, form: "" },
  786: { name: "Tapu-Lele", icon: "tapu-lele", baseId: 786, form: "" },
  787: { name: "Tapu-Bulu", icon: "tapu-bulu", baseId: 787, form: "" },
  788: { name: "Tapu-Fini", icon: "tapu-fini", baseId: 788, form: "" },
  789: { name: "Cosmog", icon: "cosmog", baseId: 789, form: "" },
  790: { name: "Cosmoem", icon: "cosmoem", baseId: 790, form: "" },
  791: { name: "Solgaleo", icon: "solgaleo", baseId: 791, form: "" },
  792: { name: "Lunala", icon: "lunala", baseId: 792, form: "" },
  793: { name: "Nihilego", icon: "nihilego", baseId: 793, form: "" },
  794: { name: "Buzzwole", icon: "buzzwole", baseId: 794, form: "" },
  795: { name: "Pheromosa", icon: "pheromosa", baseId: 795, form: "" },
  796: { name: "Xurkitree", icon: "xurkitree", baseId: 796, form: "" },
  797: { name: "Celesteela", icon: "celesteela", baseId: 797, form: "" },
  798: { name: "Kartana", icon: "kartana", baseId: 798, form: "" },
  799: { name: "Guzzlord", icon: "guzzlord", baseId: 799, form: "" },
  800: { name: "Necrozma", icon: "necrozma", baseId: 800, form: "" },
  801: { name: "Magearna", icon: "magearna", baseId: 801, form: "" },
  802: { name: "Marshadow", icon: "marshadow", baseId: 802, form: "" },
  803: { name: "Poipole", icon: "poipole", baseId: 803, form: "" },
  804: { name: "Naganadel", icon: "naganadel", baseId: 804, form: "" },
  805: { name: "Stakataka", icon: "stakataka", baseId: 805, form: "" },
  806: { name: "Blacephalon", icon: "blacephalon", baseId: 806, form: "" },
  807: { name: "Zeraora", icon: "zeraora", baseId: 807, form: "" },
  808: { name: "Meltan", icon: "meltan", baseId: 808, form: "" },
  809: { name: "Melmetal", icon: "melmetal", baseId: 809, form: "" },
  810: { name: "Grookey", icon: "grookey", baseId: 810, form: "" },
  811: { name: "Thwackey", icon: "thwackey", baseId: 811, form: "" },
  812: { name: "Rillaboom", icon: "rillaboom", baseId: 812, form: "" },
  813: { name: "Scorbunny", icon: "scorbunny", baseId: 813, form: "" },
  814: { name: "Raboot", icon: "raboot", baseId: 814, form: "" },
  815: { name: "Cinderace", icon: "cinderace", baseId: 815, form: "" },
  816: { name: "Sobble", icon: "sobble", baseId: 816, form: "" },
  817: { name: "Drizzile", icon: "drizzile", baseId: 817, form: "" },
  818: { name: "Inteleon", icon: "inteleon", baseId: 818, form: "" },
  819: { name: "Skwovet", icon: "skwovet", baseId: 819, form: "" },
  820: { name: "Greedent", icon: "greedent", baseId: 820, form: "" },
  821: { name: "Rookidee", icon: "rookidee", baseId: 821, form: "" },
  822: { name: "Corvisquire", icon: "corvisquire", baseId: 822, form: "" },
  823: { name: "Corviknight", icon: "corviknight", baseId: 823, form: "" },
  824: { name: "Blipbug", icon: "blipbug", baseId: 824, form: "" },
  825: { name: "Dottler", icon: "dottler", baseId: 825, form: "" },
  826: { name: "Orbeetle", icon: "orbeetle", baseId: 826, form: "" },
  827: { name: "Nickit", icon: "nickit", baseId: 827, form: "" },
  828: { name: "Thievul", icon: "thievul", baseId: 828, form: "" },
  829: { name: "Gossifleur", icon: "gossifleur", baseId: 829, form: "" },
  830: { name: "Eldegoss", icon: "eldegoss", baseId: 830, form: "" },
  831: { name: "Wooloo", icon: "wooloo", baseId: 831, form: "" },
  832: { name: "Dubwool", icon: "dubwool", baseId: 832, form: "" },
  833: { name: "Chewtle", icon: "chewtle", baseId: 833, form: "" },
  834: { name: "Drednaw", icon: "drednaw", baseId: 834, form: "" },
  835: { name: "Yamper", icon: "yamper", baseId: 835, form: "" },
  836: { name: "Boltund", icon: "boltund", baseId: 836, form: "" },
  837: { name: "Rolycoly", icon: "rolycoly", baseId: 837, form: "" },
  838: { name: "Carkol", icon: "carkol", baseId: 838, form: "" },
  839: { name: "Coalossal", icon: "coalossal", baseId: 839, form: "" },
  840: { name: "Applin", icon: "applin", baseId: 840, form: "" },
  841: { name: "Flapple", icon: "flapple", baseId: 841, form: "" },
  842: { name: "Appletun", icon: "appletun", baseId: 842, form: "" },
  843: { name: "Silicobra", icon: "silicobra", baseId: 843, form: "" },
  844: { name: "Sandaconda", icon: "sandaconda", baseId: 844, form: "" },
  845: { name: "Cramorant", icon: "cramorant", baseId: 845, form: "" },
  846: { name: "Arrokuda", icon: "arrokuda", baseId: 846, form: "" },
  847: { name: "Barraskewda", icon: "barraskewda", baseId: 847, form: "" },
  848: { name: "Toxel", icon: "toxel", baseId: 848, form: "" },
  849: { name: "Toxtricity-Amped", icon: "toxtricity-amped", baseId: 849, form: "Amped" },
  850: { name: "Sizzlipede", icon: "sizzlipede", baseId: 850, form: "" },
  851: { name: "Centiskorch", icon: "centiskorch", baseId: 851, form: "" },
  852: { name: "Clobbopus", icon: "clobbopus", baseId: 852, form: "" },
  853: { name: "Grapploct", icon: "grapploct", baseId: 853, form: "" },
  854: { name: "Sinistea-Phony", icon: "sinistea-phony", baseId: 854, form: "Phony" },
  855: { name: "Polteageist-Phony", icon: "polteageist", baseId: 855, form: "Phony" },
  856: { name: "Hatenna", icon: "hatenna", baseId: 856, form: "" },
  857: { name: "Hattrem", icon: "hattrem", baseId: 857, form: "" },
  858: { name: "Hatterene", icon: "hatterene", baseId: 858, form: "" },
  859: { name: "Impidimp", icon: "impidimp", baseId: 859, form: "" },
  860: { name: "Morgrem", icon: "morgrem", baseId: 860, form: "" },
  861: { name: "Grimmsnarl", icon: "grimmsnarl", baseId: 861, form: "" },
  862: { name: "Obstagoon", icon: "obstagoon", baseId: 862, form: "" },
  863: { name: "Perrserker", icon: "perrserker", baseId: 863, form: "" },
  864: { name: "Cursola", icon: "cursola", baseId: 864, form: "" },
  865: { name: "Sirfetch'd", icon: "sirfetchd", baseId: 865, form: "" },
  866: { name: "Mr. Rime", icon: "mr-rime", baseId: 866, form: "" },
  867: { name: "Runerigus", icon: "runerigus", baseId: 867, form: "" },
  868: { name: "Milcery", icon: "milcery", baseId: 868, form: "" },
  869: { name: "Alcremie-Strawberry-Vanilla-Cream", icon: "alcremie-strawberry-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  870: { name: "Falinks", icon: "falinks", baseId: 870, form: "" },
  871: { name: "Pincurchin", icon: "pincurchin", baseId: 871, form: "" },
  872: { name: "Snom", icon: "snom", baseId: 872, form: "" },
  873: { name: "Frosmoth", icon: "frosmoth", baseId: 873, form: "" },
  874: { name: "Stonjourner", icon: "stonjourner", baseId: 874, form: "" },
  875: { name: "Eiscue-Ice", icon: "eiscue", baseId: 875, form: "Ice" },
  876: { name: "Indeedee-M", icon: "indeedee", baseId: 876, form: "M" },
  877: { name: "Morpeko-Full-Belly", icon: "morpeko", baseId: 877, form: "Full Belly" },
  878: { name: "Cufant", icon: "cufant", baseId: 878, form: "" },
  879: { name: "Copperajah", icon: "copperajah", baseId: 879, form: "" },
  880: { name: "Dracozolt", icon: "dracozolt", baseId: 880, form: "" },
  881: { name: "Arctozolt", icon: "arctozolt", baseId: 881, form: "" },
  882: { name: "Dracovish", icon: "dracovish", baseId: 882, form: "" },
  883: { name: "Arctovish", icon: "arctovish", baseId: 883, form: "" },
  884: { name: "Duraludon", icon: "duraludon", baseId: 884, form: "" },
  885: { name: "Dreepy", icon: "dreepy", baseId: 885, form: "" },
  886: { name: "Drakloak", icon: "drakloak", baseId: 886, form: "" },
  887: { name: "Dragapult", icon: "dragapult", baseId: 887, form: "" },
  888: { name: "Zacian-Hero", icon: "zacian-hero", baseId: 888, form: "Hero" },
  889: { name: "Zamazenta-Hero", icon: "zamazenta-hero", baseId: 889, form: "Hero" },
  890: { name: "Eternatus", icon: "eternatus", baseId: 890, form: "" },
  891: { name: "Kubfu", icon: "kubfu", baseId: 891, form: "" },
  892: { name: "Urshifu-Single-Strike", icon: "urshifu-single-strike", baseId: 892, form: "Single Strike" },
  893: { name: "Zarude", icon: "zarude", baseId: 893, form: "" },
  894: { name: "Regieleki", icon: "regieleki", baseId: 894, form: "" },
  895: { name: "Regidrago", icon: "regidrago", baseId: 895, form: "" },
  896: { name: "Glastrier", icon: "glastrier", baseId: 896, form: "" },
  897: { name: "Spectrier", icon: "spectrier", baseId: 897, form: "" },
  898: { name: "Calyrex", icon: "calyrex", baseId: 898, form: "" },
  899: { name: "Wyrdeer", icon: "wyrdeer", baseId: 899, form: "" },
  900: { name: "Kleavor", icon: "kleavor", baseId: 900, form: "" },
  901: { name: "Ursaluna", icon: "ursaluna", baseId: 901, form: "" },
  902: { name: "Basculegion-M", icon: "basculegion", baseId: 902, form: "M" },
  903: { name: "Sneasler", icon: "sneasler", baseId: 903, form: "" },
  904: { name: "Overqwil", icon: "overqwil", baseId: 904, form: "" },
  905: { name: "Enamorus-Incarnate", icon: "enamorus", baseId: 905, form: "Incarnate" },
  906: { name: "Venusaur-Mega", icon: "venusaur-mega", baseId: 3, form: "Mega" },
  907: { name: "Charizard-Mega-X", icon: "charizard-mega-x", baseId: 6, form: "Mega X" },
  908: { name: "Charizard-Mega-Y", icon: "charizard-mega-y", baseId: 6, form: "Mega Y" },
  909: { name: "Blastoise-Mega", icon: "blastoise-mega", baseId: 9, form: "Mega" },
  910: { name: "Beedrill-Mega", icon: "beedrill-mega", baseId: 15, form: "Mega" },
  911: { name: "Pidgeot-Mega", icon: "pidgeot-mega", baseId: 18, form: "Mega" },
  912: { name: "Alakazam-Mega", icon: "alakazam-mega", baseId: 65, form: "Mega" },
  913: { name: "Slowbro-Mega", icon: "slowbro-mega", baseId: 80, form: "Mega" },
  914: { name: "Gengar-Mega", icon: "gengar-mega", baseId: 94, form: "Mega" },
  915: { name: "Kangaskhan-Mega", icon: "kangaskhan-mega", baseId: 115, form: "Mega" },
  916: { name: "Pinsir-Mega", icon: "pinsir-mega", baseId: 127, form: "Mega" },
  917: { name: "Gyarados-Mega", icon: "gyarados-mega", baseId: 130, form: "Mega" },
  918: { name: "Aerodactyl-Mega", icon: "aerodactyl-mega", baseId: 142, form: "Mega" },
  919: { name: "Mewtwo-Mega-X", icon: "mewtwo-mega-x", baseId: 150, form: "Mega X" },
  920: { name: "Mewtwo-Mega-Y", icon: "mewtwo-mega-y", baseId: 150, form: "Mega Y" },
  921: { name: "Ampharos-Mega", icon: "ampharos-mega", baseId: 181, form: "Mega" },
  922: { name: "Steelix-Mega", icon: "steelix-mega", baseId: 208, form: "Mega" },
  923: { name: "Scizor-Mega", icon: "scizor-mega", baseId: 212, form: "Mega" },
  924: { name: "Heracross-Mega", icon: "heracross-mega", baseId: 214, form: "Mega" },
  925: { name: "Houndoom-Mega", icon: "houndoom-mega", baseId: 229, form: "Mega" },
  926: { name: "Tyranitar-Mega", icon: "tyranitar-mega", baseId: 248, form: "Mega" },
  927: { name: "Sceptile-Mega", icon: "sceptile-mega", baseId: 254, form: "Mega" },
  928: { name: "Blaziken-Mega", icon: "blaziken-mega", baseId: 257, form: "Mega" },
  929: { name: "Swampert-Mega", icon: "swampert-mega", baseId: 260, form: "Mega" },
  930: { name: "Gardevoir-Mega", icon: "gardevoir-mega", baseId: 282, form: "Mega" },
  931: { name: "Sableye-Mega", icon: "sableye-mega", baseId: 302, form: "Mega" },
  932: { name: "Mawile-Mega", icon: "mawile-mega", baseId: 303, form: "Mega" },
  933: { name: "Aggron-Mega", icon: "aggron-mega", baseId: 306, form: "Mega" },
  934: { name: "Medicham-Mega", icon: "medicham-mega", baseId: 308, form: "Mega" },
  935: { name: "Manectric-Mega", icon: "manectric-mega", baseId: 310, form: "Mega" },
  936: { name: "Sharpedo-Mega", icon: "sharpedo-mega", baseId: 319, form: "Mega" },
  937: { name: "Camerupt-Mega", icon: "camerupt-mega", baseId: 323, form: "Mega" },
  938: { name: "Altaria-Mega", icon: "altaria-mega", baseId: 334, form: "Mega" },
  939: { name: "Banette-Mega", icon: "banette-mega", baseId: 354, form: "Mega" },
  940: { name: "Absol-Mega", icon: "absol-mega", baseId: 359, form: "Mega" },
  941: { name: "Glalie-Mega", icon: "glalie-mega", baseId: 362, form: "Mega" },
  942: { name: "Salamence-Mega", icon: "salamence-mega", baseId: 373, form: "Mega" },
  943: { name: "Metagross-Mega", icon: "metagross-mega", baseId: 376, form: "Mega" },
  944: { name: "Latias-Mega", icon: "latias-mega", baseId: 380, form: "Mega" },
  945: { name: "Latios-Mega", icon: "latios-mega", baseId: 381, form: "Mega" },
  946: { name: "Lopunny-Mega", icon: "lopunny-mega", baseId: 428, form: "Mega" },
  947: { name: "Garchomp-Mega", icon: "garchomp-mega", baseId: 445, form: "Mega" },
  948: { name: "Lucario-Mega", icon: "lucario-mega", baseId: 448, form: "Mega" },
  949: { name: "Abomasnow-Mega", icon: "abomasnow-mega", baseId: 460, form: "Mega" },
  950: { name: "Gallade-Mega", icon: "gallade-mega", baseId: 475, form: "Mega" },
  951: { name: "Audino-Mega", icon: "audino-mega", baseId: 531, form: "Mega" },
  952: { name: "Diancie-Mega", icon: "diancie-mega", baseId: 719, form: "Mega" },
  953: { name: "Rayquaza-Mega", icon: "rayquaza-mega", baseId: 384, form: "Mega" },
  954: { name: "Kyogre-Primal", icon: "kyogre-primal", baseId: 382, form: "Primal" },
  955: { name: "Groudon-Primal", icon: "groudon-primal", baseId: 383, form: "Primal" },
  956: { name: "Rattata-Alola", icon: "rattata-alola", baseId: 19, form: "Alola" },
  957: { name: "Raticate-Alola", icon: "raticate-alola", baseId: 20, form: "Alola" },
  958: { name: "Raichu-Alola", icon: "raichu-alola", baseId: 26, form: "Alola" },
  959: { name: "Sandshrew-Alola", icon: "sandshrew-alola", baseId: 27, form: "Alola" },
  960: { name: "Sandslash-Alola", icon: "sandslash-alola", baseId: 28, form: "Alola" },
  961: { name: "Vulpix-Alola", icon: "vulpix", baseId: 37, form: "Alola" },
  962: { name: "Ninetales-Alola", icon: "ninetales-alola", baseId: 38, form: "Alola" },
  963: { name: "Diglett-Alola", icon: "diglett-alola", baseId: 50, form: "Alola" },
  964: { name: "Dugtrio-Alola", icon: "dugtrio-alola", baseId: 51, form: "Alola" },
  965: { name: "Meowth-Alola", icon: "meowth-alola", baseId: 52, form: "Alola" },
  966: { name: "Persian-Alola", icon: "persian-alola", baseId: 53, form: "Alola" },
  967: { name: "Geodude-Alola", icon: "geodude-alola", baseId: 74, form: "Alola" },
  968: { name: "Graveler-Alola", icon: "graveler-alola", baseId: 75, form: "Alola" },
  969: { name: "Golem-Alola", icon: "golem-alola", baseId: 76, form: "Alola" },
  970: { name: "Grimer-Alola", icon: "grimer-alola", baseId: 88, form: "Alola" },
  971: { name: "Muk-Alola", icon: "muk-alola", baseId: 89, form: "Alola" },
  972: { name: "Exeggutor-Alola", icon: "exeggutor-alola", baseId: 103, form: "Alola" },
  973: { name: "Marowak-Alola", icon: "marowak-alola", baseId: 105, form: "Alola" },
  974: { name: "Meowth-Galar", icon: "meowth-galar", baseId: 52, form: "Galar" },
  975: { name: "Ponyta-Galar", icon: "ponyta-galar", baseId: 77, form: "Galar" },
  976: { name: "Rapidash-Galar", icon: "rapidash-galar", baseId: 78, form: "Galar" },
  977: { name: "Slowpoke-Galar", icon: "slowpoke-galar", baseId: 79, form: "Galar" },
  978: { name: "Slowbro-Galar", icon: "slowbro-galar", baseId: 80, form: "Galar" },
  979: { name: "Farfetch'd-Galar", icon: "farfetch'd", baseId: 83, form: "Galar" },
  980: { name: "Weezing-Galar", icon: "weezing-galar", baseId: 110, form: "Galar" },
  981: { name: "Mr. Mime-Galar", icon: "mr-mime-galar", baseId: 122, form: "Galar" },
  982: { name: "Articuno-Galar", icon: "articuno-galar", baseId: 144, form: "Galar" },
  983: { name: "Zapdos-Galar", icon: "zapdos-galar", baseId: 145, form: "Galar" },
  984: { name: "Moltres-Galar", icon: "moltres-galar", baseId: 146, form: "Galar" },
  985: { name: "Slowking-Galar", icon: "slowking-galar", baseId: 199, form: "Galar" },
  986: { name: "Corsola-Galar", icon: "corsola-galar", baseId: 222, form: "Galar" },
  987: { name: "Zigzagoon-Galar", icon: "zigzagoon", baseId: 263, form: "Galar" },
  988: { name: "Linoone-Galar", icon: "linoone-galar", baseId: 264, form: "Galar" },
  989: { name: "Darumaka-Galar", icon: "darumaka-galar", baseId: 554, form: "Galar" },
  990: { name: "Darmanitan-Galar-Standard", icon: "darmanitan-galar", baseId: 555, form: "Standard" },
  991: { name: "Yamask-Galar", icon: "yamask-galar", baseId: 562, form: "Galar" },
  992: { name: "Stunfisk-Galar", icon: "stunfisk", baseId: 618, form: "Galar" },
  993: { name: "Growlithe-Hisui", icon: "growlithe-hisui", baseId: 58, form: "Hisui" },
  994: { name: "Arcanine-Hisui", icon: "arcanine-hisui", baseId: 59, form: "Hisui" },
  995: { name: "Voltorb-Hisui", icon: "voltorb", baseId: 100, form: "Hisui" },
  996: { name: "Electrode-Hisui", icon: "electrode-hisui", baseId: 101, form: "Hisui" },
  997: { name: "Typhlosion-Hisui", icon: "typhlosion-hisui", baseId: 157, form: "Hisui" },
  998: { name: "Qwilfish-Hisui", icon: "qwilfish-hisui", baseId: 211, form: "Hisui" },
  999: { name: "Sneasel-Hisui", icon: "sneasel", baseId: 215, form: "Hisui" },
  1000: { name: "Samurott-Hisui", icon: "samurott-hisui", baseId: 503, form: "Hisui" },
  1001: { name: "Lilligant-Hisui", icon: "lilligant-hisui", baseId: 549, form: "Hisui" },
  1002: { name: "Zorua-Hisui", icon: "zorua", baseId: 570, form: "Hisui" },
  1003: { name: "Zoroark-Hisui", icon: "zoroark-hisui", baseId: 571, form: "Hisui" },
  1004: { name: "Braviary-Hisui", icon: "braviary-hisui", baseId: 628, form: "Hisui" },
  1005: { name: "Sliggoo-Hisui", icon: "sliggoo-hisui", baseId: 705, form: "Hisui" },
  1006: { name: "Goodra-Hisui", icon: "goodra-hisui", baseId: 706, form: "Hisui" },
  1007: { name: "Avalugg-Hisui", icon: "avalugg-hisui", baseId: 713, form: "Hisui" },
  1008: { name: "Decidueye-Hisui", icon: "decidueye-hisui", baseId: 724, form: "Hisui" },
  1009: { name: "Pikachu-Cosplay", icon: "pikachu-cosplay", baseId: 25, form: "Cosplay" },
  1010: { name: "Pikachu-Rock-Star", icon: "pikachu-rock-star", baseId: 25, form: "Rock Star" },
  1011: { name: "Pikachu-Belle", icon: "pikachu-belle", baseId: 25, form: "Belle" },
  1012: { name: "Pikachu-Pop-Star", icon: "pikachu-pop-star", baseId: 25, form: "Pop Star" },
  1013: { name: "Pikachu-Phd", icon: "pikachu-phd", baseId: 25, form: "Phd" },
  1014: { name: "Pikachu-Libre", icon: "pikachu-libre", baseId: 25, form: "Libre" },
  1015: { name: "Pikachu-Original", icon: "pikachu", baseId: 25, form: "Original" },
  1016: { name: "Pikachu-Hoenn", icon: "pikachu", baseId: 25, form: "Hoenn" },
  1017: { name: "Pikachu-Sinnoh", icon: "pikachu", baseId: 25, form: "Sinnoh" },
  1018: { name: "Pikachu-Unova", icon: "pikachu", baseId: 25, form: "Unova" },
  1019: { name: "Pikachu-Kalos", icon: "pikachu", baseId: 25, form: "Kalos" },
  1020: { name: "Pikachu-Alola", icon: "pikachu", baseId: 25, form: "Alola" },
  1021: { name: "Pikachu-Partner", icon: "pikachu", baseId: 25, form: "Partner" },
  1022: { name: "Pikachu-World", icon: "pikachu", baseId: 25, form: "World" },
  1023: { name: "Pichu-Spiky-Eared", icon: "pichu-spiky-eared", baseId: 172, form: "Spiky Eared" },
  1024: { name: "Unown-B", icon: "unown-b", baseId: 201, form: "B" },
  1025: { name: "Unown-C", icon: "unown-c", baseId: 201, form: "C" },
  1026: { name: "Unown-D", icon: "unown-d", baseId: 201, form: "D" },
  1027: { name: "Unown-E", icon: "unown-e", baseId: 201, form: "E" },
  1028: { name: "Unown-F", icon: "unown-f", baseId: 201, form: "F" },
  1029: { name: "Unown-G", icon: "unown-g", baseId: 201, form: "G" },
  1030: { name: "Unown-H", icon: "unown-h", baseId: 201, form: "H" },
  1031: { name: "Unown-I", icon: "unown-i", baseId: 201, form: "I" },
  1032: { name: "Unown-J", icon: "unown-j", baseId: 201, form: "J" },
  1033: { name: "Unown-K", icon: "unown-k", baseId: 201, form: "K" },
  1034: { name: "Unown-L", icon: "unown-l", baseId: 201, form: "L" },
  1035: { name: "Unown-M", icon: "unown-m", baseId: 201, form: "M" },
  1036: { name: "Unown-N", icon: "unown-n", baseId: 201, form: "N" },
  1037: { name: "Unown-O", icon: "unown-o", baseId: 201, form: "O" },
  1038: { name: "Unown-P", icon: "unown-p", baseId: 201, form: "P" },
  1039: { name: "Unown-Q", icon: "unown-q", baseId: 201, form: "Q" },
  1040: { name: "Unown-R", icon: "unown-r", baseId: 201, form: "R" },
  1041: { name: "Unown-S", icon: "unown-s", baseId: 201, form: "S" },
  1042: { name: "Unown-T", icon: "unown-t", baseId: 201, form: "T" },
  1043: { name: "Unown-U", icon: "unown-u", baseId: 201, form: "U" },
  1044: { name: "Unown-V", icon: "unown-v", baseId: 201, form: "V" },
  1045: { name: "Unown-W", icon: "unown-w", baseId: 201, form: "W" },
  1046: { name: "Unown-X", icon: "unown-x", baseId: 201, form: "X" },
  1047: { name: "Unown-Y", icon: "unown-y", baseId: 201, form: "Y" },
  1048: { name: "Unown-Z", icon: "unown-z", baseId: 201, form: "Z" },
  1049: { name: "Unown-Exclamation", icon: "unown-exclamation", baseId: 201, form: "Exclamation" },
  1050: { name: "Unown-Question", icon: "unown-question", baseId: 201, form: "Question" },
  1051: { name: "Castform-Sunny", icon: "castform-sunny", baseId: 351, form: "Sunny" },
  1052: { name: "Castform-Rainy", icon: "castform-rainy", baseId: 351, form: "Rainy" },
  1053: { name: "Castform-Snowy", icon: "castform-snowy", baseId: 351, form: "Snowy" },
  1054: { name: "Deoxys-Attack", icon: "deoxys-attack", baseId: 386, form: "Attack" },
  1055: { name: "Deoxys-Defense", icon: "deoxys-defense", baseId: 386, form: "Defense" },
  1056: { name: "Deoxys-Speed", icon: "deoxys-speed", baseId: 386, form: "Speed" },
  1057: { name: "Burmy-Sandy", icon: "burmy-sandy", baseId: 412, form: "Sandy" },
  1058: { name: "Burmy-Trash", icon: "burmy-trash", baseId: 412, form: "Trash" },
  1059: { name: "Wormadam-Sandy", icon: "wormadam-sandy", baseId: 413, form: "Sandy" },
  1060: { name: "Wormadam-Trash", icon: "wormadam-trash", baseId: 413, form: "Trash" },
  1061: { name: "Cherrim-Sunshine", icon: "cherrim-sunshine", baseId: 421, form: "Sunshine" },
  1062: { name: "Shellos-East", icon: "shellos-east", baseId: 422, form: "East" },
  1063: { name: "Gastrodon-East", icon: "gastrodon-east", baseId: 423, form: "East" },
  1064: { name: "Rotom-Heat", icon: "rotom-heat", baseId: 479, form: "Heat" },
  1065: { name: "Rotom-Wash", icon: "rotom-wash", baseId: 479, form: "Wash" },
  1066: { name: "Rotom-Frost", icon: "rotom-frost", baseId: 479, form: "Frost" },
  1067: { name: "Rotom-Fan", icon: "rotom-fan", baseId: 479, form: "Fan" },
  1068: { name: "Rotom-Mow", icon: "rotom-mow", baseId: 479, form: "Mow" },
  1069: { name: "Dialga-Origin", icon: "dialga", baseId: 483, form: "Origin" },
  1070: { name: "Palkia-Origin", icon: "palkia-origin", baseId: 484, form: "Origin" },
  1071: { name: "Giratina-Origin", icon: "giratina-origin", baseId: 487, form: "Origin" },
  1072: { name: "Shaymin-Sky", icon: "shaymin-sky", baseId: 492, form: "Sky" },
  1073: { name: "Arceus-Fighting", icon: "arceus-fighting", baseId: 493, form: "Fighting" },
  1074: { name: "Arceus-Flying", icon: "arceus-flying", baseId: 493, form: "Flying" },
  1075: { name: "Arceus-Poison", icon: "arceus-poison", baseId: 493, form: "Poison" },
  1076: { name: "Arceus-Ground", icon: "arceus-ground", baseId: 493, form: "Ground" },
  1077: { name: "Arceus-Rock", icon: "arceus-rock", baseId: 493, form: "Rock" },
  1078: { name: "Arceus-Bug", icon: "arceus-bug", baseId: 493, form: "Bug" },
  1079: { name: "Arceus-Ghost", icon: "arceus-ghost", baseId: 493, form: "Ghost" },
  1080: { name: "Arceus-Steel", icon: "arceus-steel", baseId: 493, form: "Steel" },
  1081: { name: "Arceus-Fire", icon: "arceus-fire", baseId: 493, form: "Fire" },
  1082: { name: "Arceus-Water", icon: "arceus-water", baseId: 493, form: "Water" },
  1083: { name: "Arceus-Grass", icon: "arceus-grass", baseId: 493, form: "Grass" },
  1084: { name: "Arceus-Electric", icon: "arceus-electric", baseId: 493, form: "Electric" },
  1085: { name: "Arceus-Psychic", icon: "arceus-psychic", baseId: 493, form: "Psychic" },
  1086: { name: "Arceus-Ice", icon: "arceus-ice", baseId: 493, form: "Ice" },
  1087: { name: "Arceus-Dragon", icon: "arceus-dragon", baseId: 493, form: "Dragon" },
  1088: { name: "Arceus-Dark", icon: "arceus-dark", baseId: 493, form: "Dark" },
  1089: { name: "Arceus-Fairy", icon: "arceus-fairy", baseId: 493, form: "Fairy" },
  1090: { name: "Basculin-Blue-Striped", icon: "basculin-blue-striped", baseId: 550, form: "Blue Striped" },
  1091: { name: "Basculin-White-Striped", icon: "basculin-white-striped", baseId: 550, form: "White Striped" },
  1092: { name: "Darmanitan-Zen", icon: "darmanitan-zen", baseId: 555, form: "Zen" },
  1093: { name: "Darmanitan-Galar-Zen", icon: "darmanitan-galar-zen", baseId: 555, form: "Zen" },
  1094: { name: "Deerling-Summer", icon: "deerling-summer", baseId: 585, form: "Summer" },
  1095: { name: "Deerling-Autumn", icon: "deerling-autumn", baseId: 585, form: "Autumn" },
  1096: { name: "Deerling-Winter", icon: "deerling-winter", baseId: 585, form: "Winter" },
  1097: { name: "Sawsbuck-Summer", icon: "sawsbuck-summer", baseId: 586, form: "Summer" },
  1098: { name: "Sawsbuck-Autumn", icon: "sawsbuck-autumn", baseId: 586, form: "Autumn" },
  1099: { name: "Sawsbuck-Winter", icon: "sawsbuck-winter", baseId: 586, form: "Winter" },
  1100: { name: "Tornadus-Therian", icon: "tornadus-therian", baseId: 641, form: "Therian" },
  1101: { name: "Thundurus-Therian", icon: "thundurus-therian", baseId: 642, form: "Therian" },
  1102: { name: "Landorus-Therian", icon: "landorus-therian", baseId: 645, form: "Therian" },
  1103: { name: "Enamorus-Therian", icon: "enamorus-therian", baseId: 905, form: "Therian" },
  1104: { name: "Kyurem-White", icon: "kyurem-white", baseId: 646, form: "White" },
  1105: { name: "Kyurem-Black", icon: "kyurem-black", baseId: 646, form: "Black" },
  1106: { name: "Keldeo-Resolute", icon: "keldeo-resolute", baseId: 647, form: "Resolute" },
  1107: { name: "Meloetta-Pirouette", icon: "meloetta-pirouette", baseId: 648, form: "Pirouette" },
  1108: { name: "Genesect-Douse", icon: "genesect-douse", baseId: 649, form: "Douse" },
  1109: { name: "Genesect-Shock", icon: "genesect-shock", baseId: 649, form: "Shock" },
  1110: { name: "Genesect-Burn", icon: "genesect-burn", baseId: 649, form: "Burn" },
  1111: { name: "Genesect-Chill", icon: "genesect-chill", baseId: 649, form: "Chill" },
  1112: { name: "Greninja-Bond", icon: "greninja", baseId: 658, form: "Bond" },
  1113: { name: "Greninja-Ash", icon: "greninja-ash", baseId: 658, form: "Ash" },
  1114: { name: "Vivillon-Polar", icon: "vivillon-polar", baseId: 666, form: "Polar" },
  1115: { name: "Vivillon-Tundra", icon: "vivillon-tundra", baseId: 666, form: "Tundra" },
  1116: { name: "Vivillon-Continental", icon: "vivillon-continental", baseId: 666, form: "Continental" },
  1117: { name: "Vivillon-Garden", icon: "vivillon-garden", baseId: 666, form: "Garden" },
  1118: { name: "Vivillon-Elegant", icon: "vivillon-elegant", baseId: 666, form: "Elegant" },
  1119: { name: "Vivillon-Meadow", icon: "vivillon-meadow", baseId: 666, form: "Meadow" },
  1120: { name: "Vivillon-Modern", icon: "vivillon-modern", baseId: 666, form: "Modern" },
  1121: { name: "Vivillon-Marine", icon: "vivillon-marine", baseId: 666, form: "Marine" },
  1122: { name: "Vivillon-Archipelago", icon: "vivillon-archipelago", baseId: 666, form: "Archipelago" },
  1123: { name: "Vivillon-High-Plains", icon: "vivillon-high-plains", baseId: 666, form: "High Plains" },
  1124: { name: "Vivillon-Sandstorm", icon: "vivillon-sandstorm", baseId: 666, form: "Sandstorm" },
  1125: { name: "Vivillon-River", icon: "vivillon-river", baseId: 666, form: "River" },
  1126: { name: "Vivillon-Monsoon", icon: "vivillon-monsoon", baseId: 666, form: "Monsoon" },
  1127: { name: "Vivillon-Savanna", icon: "vivillon-savanna", baseId: 666, form: "Savanna" },
  1128: { name: "Vivillon-Sun", icon: "vivillon-sun", baseId: 666, form: "Sun" },
  1129: { name: "Vivillon-Ocean", icon: "vivillon-ocean", baseId: 666, form: "Ocean" },
  1130: { name: "Vivillon-Jungle", icon: "vivillon-jungle", baseId: 666, form: "Jungle" },
  1131: { name: "Vivillon-Fancy", icon: "vivillon-fancy", baseId: 666, form: "Fancy" },
  1132: { name: "Vivillon-Pokeball", icon: "vivillon-pokeball", baseId: 666, form: "Pokeball" },
  1133: { name: "Flabébé-Yellow", icon: "flabebe-yellow", baseId: 669, form: "Yellow" },
  1134: { name: "Flabébé-Orange", icon: "flabebe-orange", baseId: 669, form: "Orange" },
  1135: { name: "Flabébé-Blue", icon: "flabebe-blue", baseId: 669, form: "Blue" },
  1136: { name: "Flabébé-White", icon: "flabebe-white", baseId: 669, form: "White" },
  1137: { name: "Floette-Yellow", icon: "floette-yellow", baseId: 670, form: "Yellow" },
  1138: { name: "Floette-Orange", icon: "floette-orange", baseId: 670, form: "Orange" },
  1139: { name: "Floette-Blue", icon: "floette-blue", baseId: 670, form: "Blue" },
  1140: { name: "Floette-White", icon: "floette-white", baseId: 670, form: "White" },
  1141: { name: "Floette-Eternal", icon: "floette-eternal", baseId: 670, form: "Eternal" },
  1142: { name: "Florges-Yellow", icon: "florges-yellow", baseId: 671, form: "Yellow" },
  1143: { name: "Florges-Orange", icon: "florges-orange", baseId: 671, form: "Orange" },
  1144: { name: "Florges-Blue", icon: "florges-blue", baseId: 671, form: "Blue" },
  1145: { name: "Florges-White", icon: "florges-white", baseId: 671, form: "White" },
  1146: { name: "Furfrou-Heart", icon: "furfrou-heart", baseId: 676, form: "Heart" },
  1147: { name: "Furfrou-Star", icon: "furfrou-star", baseId: 676, form: "Star" },
  1148: { name: "Furfrou-Diamond", icon: "furfrou-diamond", baseId: 676, form: "Diamond" },
  1149: { name: "Furfrou-Debutante", icon: "furfrou-debutante", baseId: 676, form: "Debutante" },
  1150: { name: "Furfrou-Matron", icon: "furfrou-matron", baseId: 676, form: "Matron" },
  1151: { name: "Furfrou-Dandy", icon: "furfrou-dandy", baseId: 676, form: "Dandy" },
  1152: { name: "Furfrou-La-Reine", icon: "furfrou-la-reine", baseId: 676, form: "La Reine" },
  1153: { name: "Furfrou-Kabuki", icon: "furfrou-kabuki", baseId: 676, form: "Kabuki" },
  1154: { name: "Furfrou-Pharaoh", icon: "furfrou-pharaoh", baseId: 676, form: "Pharaoh" },
  1155: { name: "Meowstic-F", icon: "meowstic-f", baseId: 678, form: "F" },
  1156: { name: "Aegislash-Blade", icon: "aegislash-blade", baseId: 681, form: "Blade" },
  1157: { name: "Pumpkaboo-Small", icon: "pumpkaboo-small", baseId: 710, form: "Small" },
  1158: { name: "Pumpkaboo-Large", icon: "pumpkaboo-large", baseId: 710, form: "Large" },
  1159: { name: "Pumpkaboo-Super", icon: "pumpkaboo-super", baseId: 710, form: "Super" },
  1160: { name: "Gourgeist-Small", icon: "gourgeist-small", baseId: 711, form: "Small" },
  1161: { name: "Gourgeist-Large", icon: "gourgeist-large", baseId: 711, form: "Large" },
  1162: { name: "Gourgeist-Super", icon: "gourgeist-super", baseId: 711, form: "Super" },
  1163: { name: "Xerneas-Active", icon: "xerneas-active", baseId: 716, form: "Active" },
  1164: { name: "Zygarde-10-Aura-Break", icon: "zygarde-10-aura-break", baseId: 718, form: "Aura Break" },
  1165: { name: "Zygarde-10-Power-Construct", icon: "zygarde-10-power-construct", baseId: 718, form: "Power Construct" },
  1166: { name: "Zygarde-50-Power-Construct", icon: "zygarde-50-power-construct", baseId: 718, form: "Power Construct" },
  1167: { name: "Zygarde-Complete", icon: "zygarde-complete", baseId: 718, form: "Complete" },
  1168: { name: "Hoopa-Unbound", icon: "hoopa-unbound", baseId: 720, form: "Unbound" },
  1169: { name: "Oricorio-Pom-Pom", icon: "oricorio-pom-pom", baseId: 741, form: "Pom Pom" },
  1170: { name: "Oricorio-Pau", icon: "oricorio-pau", baseId: 741, form: "Pau" },
  1171: { name: "Oricorio-Sensu", icon: "oricorio-sensu", baseId: 741, form: "Sensu" },
  1172: { name: "Rockruff-Own-Tempo", icon: "rockruff", baseId: 744, form: "Own Tempo" },
  1173: { name: "Lycanroc-Midnight", icon: "lycanroc-midnight", baseId: 745, form: "Midnight" },
  1174: { name: "Lycanroc-Dusk", icon: "lycanroc-dusk", baseId: 745, form: "Dusk" },
  1175: { name: "Wishiwashi-School", icon: "wishiwashi", baseId: 746, form: "School" },
  1176: { name: "Silvally-Fighting", icon: "silvally-fighting", baseId: 773, form: "Fighting" },
  1177: { name: "Silvally-Flying", icon: "silvally-flying", baseId: 773, form: "Flying" },
  1178: { name: "Silvally-Poison", icon: "silvally-poison", baseId: 773, form: "Poison" },
  1179: { name: "Silvally-Ground", icon: "silvally-ground", baseId: 773, form: "Ground" },
  1180: { name: "Silvally-Rock", icon: "silvally-rock", baseId: 773, form: "Rock" },
  1181: { name: "Silvally-Bug", icon: "silvally-bug", baseId: 773, form: "Bug" },
  1182: { name: "Silvally-Ghost", icon: "silvally-ghost", baseId: 773, form: "Ghost" },
  1183: { name: "Silvally-Steel", icon: "silvally-steel", baseId: 773, form: "Steel" },
  1184: { name: "Silvally-Fire", icon: "silvally-fire", baseId: 773, form: "Fire" },
  1185: { name: "Silvally-Water", icon: "silvally-water", baseId: 773, form: "Water" },
  1186: { name: "Silvally-Grass", icon: "silvally-grass", baseId: 773, form: "Grass" },
  1187: { name: "Silvally-Electric", icon: "silvally-electric", baseId: 773, form: "Electric" },
  1188: { name: "Silvally-Psychic", icon: "silvally-psychic", baseId: 773, form: "Psychic" },
  1189: { name: "Silvally-Ice", icon: "silvally-ice", baseId: 773, form: "Ice" },
  1190: { name: "Silvally-Dragon", icon: "silvally-dragon", baseId: 773, form: "Dragon" },
  1191: { name: "Silvally-Dark", icon: "silvally-dark", baseId: 773, form: "Dark" },
  1192: { name: "Silvally-Fairy", icon: "silvally-fairy", baseId: 773, form: "Fairy" },
  1193: { name: "Minior-Meteor-Orange", icon: "minior", baseId: 774, form: "Orange" },
  1194: { name: "Minior-Meteor-Yellow", icon: "minior", baseId: 774, form: "Yellow" },
  1195: { name: "Minior-Meteor-Green", icon: "minior", baseId: 774, form: "Green" },
  1196: { name: "Minior-Meteor-Blue", icon: "minior", baseId: 774, form: "Blue" },
  1197: { name: "Minior-Meteor-Indigo", icon: "minior", baseId: 774, form: "Indigo" },
  1198: { name: "Minior-Meteor-Violet", icon: "minior", baseId: 774, form: "Violet" },
  1199: { name: "Minior-Core-Red", icon: "minior", baseId: 774, form: "Red" },
  1200: { name: "Minior-Core-Orange", icon: "minior", baseId: 774, form: "Orange" },
  1201: { name: "Minior-Core-Yellow", icon: "minior", baseId: 774, form: "Yellow" },
  1202: { name: "Minior-Core-Green", icon: "minior", baseId: 774, form: "Green" },
  1203: { name: "Minior-Core-Blue", icon: "minior", baseId: 774, form: "Blue" },
  1204: { name: "Minior-Core-Indigo", icon: "minior", baseId: 774, form: "Indigo" },
  1205: { name: "Minior-Core-Violet", icon: "minior", baseId: 774, form: "Violet" },
  1206: { name: "Mimikyu-Busted", icon: "mimikyu", baseId: 778, form: "Busted" },
  1207: { name: "Necrozma-Dusk-Mane", icon: "necrozma", baseId: 800, form: "Dusk Mane" },
  1208: { name: "Necrozma-Dawn-Wings", icon: "necrozma", baseId: 800, form: "Dawn Wings" },
  1209: { name: "Necrozma-Ultra", icon: "necrozma-ultra", baseId: 800, form: "Ultra" },
  1210: { name: "Magearna-Original", icon: "magearna-original", baseId: 801, form: "Original" },
  1211: { name: "Cramorant-Gulping", icon: "cramorant-gulping", baseId: 845, form: "Gulping" },
  1212: { name: "Cramorant-Gorging", icon: "cramorant-gorging", baseId: 845, form: "Gorging" },
  1213: { name: "Toxtricity-Low-Key", icon: "toxtricity-low-key", baseId: 849, form: "Low Key" },
  1214: { name: "Sinistea-Antique", icon: "sinistea-antique", baseId: 854, form: "Antique" },
  1215: { name: "Polteageist-Antique", icon: "polteageist", baseId: 855, form: "Antique" },
  1216: { name: "Alcremie-Strawberry-Ruby-Cream", icon: "alcremie-strawberry-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1217: { name: "Alcremie-Strawberry-Matcha-Cream", icon: "alcremie-strawberry-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1218: { name: "Alcremie-Strawberry-Mint-Cream", icon: "alcremie-strawberry-mint-cream", baseId: 869, form: "Mint Cream" },
  1219: { name: "Alcremie-Strawberry-Lemon-Cream", icon: "alcremie-strawberry-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1220: { name: "Alcremie-Strawberry-Salted-Cream", icon: "alcremie-strawberry-salted-cream", baseId: 869, form: "Salted Cream" },
  1221: { name: "Alcremie-Strawberry-Ruby-Swirl", icon: "alcremie-strawberry-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1222: { name: "Alcremie-Strawberry-Caramel-Swirl", icon: "alcremie-strawberry-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1223: { name: "Alcremie-Strawberry-Rainbow-Swirl", icon: "alcremie-strawberry-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1224: { name: "Eiscue-Noice", icon: "eiscue-noice", baseId: 875, form: "Noice" },
  1225: { name: "Indeedee-F", icon: "indeedee", baseId: 876, form: "F" },
  1226: { name: "Morpeko-Hangry", icon: "morpeko-hangry", baseId: 877, form: "Hangry" },
  1227: { name: "Zacian-Crowned", icon: "zacian-crowned", baseId: 888, form: "Crowned" },
  1228: { name: "Zamazenta-Crowned", icon: "zamazenta-crowned", baseId: 889, form: "Crowned" },
  1229: { name: "Eternatus-Eternamax", icon: "eternatus-eternamax", baseId: 890, form: "Eternamax" },
  1230: { name: "Urshifu-Rapid-Strike", icon: "urshifu-rapid-strike", baseId: 892, form: "Rapid Strike" },
  1231: { name: "Zarude-Dada", icon: "zarude-dada", baseId: 893, form: "Dada" },
  1232: { name: "Calyrex-Ice", icon: "calyrex", baseId: 898, form: "Ice" },
  1233: { name: "Calyrex-Shadow", icon: "calyrex", baseId: 898, form: "Shadow" },
  1234: { name: "Basculegion-F", icon: "basculegion", baseId: 902, form: "F" },
  1235: { name: "Alcremie-Berry-Vanilla-Cream", icon: "alcremie-berry-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1236: { name: "Alcremie-Berry-Ruby-Cream", icon: "alcremie-berry-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1237: { name: "Alcremie-Berry-Matcha-Cream", icon: "alcremie-berry-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1238: { name: "Alcremie-Berry-Mint-Cream", icon: "alcremie-berry-mint-cream", baseId: 869, form: "Mint Cream" },
  1239: { name: "Alcremie-Berry-Lemon-Cream", icon: "alcremie-berry-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1240: { name: "Alcremie-Berry-Salted-Cream", icon: "alcremie-berry-salted-cream", baseId: 869, form: "Salted Cream" },
  1241: { name: "Alcremie-Berry-Ruby-Swirl", icon: "alcremie-berry-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1242: { name: "Alcremie-Berry-Caramel-Swirl", icon: "alcremie-berry-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1243: { name: "Alcremie-Berry-Rainbow-Swirl", icon: "alcremie-berry-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1244: { name: "Alcremie-Love-Vanilla-Cream", icon: "alcremie-love-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1245: { name: "Alcremie-Love-Ruby-Cream", icon: "alcremie-love-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1246: { name: "Alcremie-Love-Matcha-Cream", icon: "alcremie-love-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1247: { name: "Alcremie-Love-Mint-Cream", icon: "alcremie-love-mint-cream", baseId: 869, form: "Mint Cream" },
  1248: { name: "Alcremie-Love-Lemon-Cream", icon: "alcremie-love-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1249: { name: "Alcremie-Love-Salted-Cream", icon: "alcremie-love-salted-cream", baseId: 869, form: "Salted Cream" },
  1250: { name: "Alcremie-Love-Ruby-Swirl", icon: "alcremie-love-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1251: { name: "Alcremie-Love-Caramel-Swirl", icon: "alcremie-love-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1252: { name: "Alcremie-Love-Rainbow-Swirl", icon: "alcremie-love-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1253: { name: "Alcremie-Star-Vanilla-Cream", icon: "alcremie-star-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1254: { name: "Alcremie-Star-Ruby-Cream", icon: "alcremie-star-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1255: { name: "Alcremie-Star-Matcha-Cream", icon: "alcremie-star-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1256: { name: "Alcremie-Star-Mint-Cream", icon: "alcremie-star-mint-cream", baseId: 869, form: "Mint Cream" },
  1257: { name: "Alcremie-Star-Lemon-Cream", icon: "alcremie-star-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1258: { name: "Alcremie-Star-Salted-Cream", icon: "alcremie-star-salted-cream", baseId: 869, form: "Salted Cream" },
  1259: { name: "Alcremie-Star-Ruby-Swirl", icon: "alcremie-star-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1260: { name: "Alcremie-Star-Caramel-Swirl", icon: "alcremie-star-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1261: { name: "Alcremie-Star-Rainbow-Swirl", icon: "alcremie-star-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1262: { name: "Alcremie-Clover-Vanilla-Cream", icon: "alcremie-clover-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1263: { name: "Alcremie-Clover-Ruby-Cream", icon: "alcremie-clover-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1264: { name: "Alcremie-Clover-Matcha-Cream", icon: "alcremie-clover-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1265: { name: "Alcremie-Clover-Mint-Cream", icon: "alcremie-clover-mint-cream", baseId: 869, form: "Mint Cream" },
  1266: { name: "Alcremie-Clover-Lemon-Cream", icon: "alcremie-clover-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1267: { name: "Alcremie-Clover-Salted-Cream", icon: "alcremie-clover-salted-cream", baseId: 869, form: "Salted Cream" },
  1268: { name: "Alcremie-Clover-Ruby-Swirl", icon: "alcremie-clover-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1269: { name: "Alcremie-Clover-Caramel-Swirl", icon: "alcremie-clover-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1270: { name: "Alcremie-Clover-Rainbow-Swirl", icon: "alcremie-clover-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1271: { name: "Alcremie-Flower-Vanilla-Cream", icon: "alcremie-flower-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1272: { name: "Alcremie-Flower-Ruby-Cream", icon: "alcremie-flower-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1273: { name: "Alcremie-Flower-Matcha-Cream", icon: "alcremie-flower-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1274: { name: "Alcremie-Flower-Mint-Cream", icon: "alcremie-flower-mint-cream", baseId: 869, form: "Mint Cream" },
  1275: { name: "Alcremie-Flower-Lemon-Cream", icon: "alcremie-flower-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1276: { name: "Alcremie-Flower-Salted-Cream", icon: "alcremie-flower-salted-cream", baseId: 869, form: "Salted Cream" },
  1277: { name: "Alcremie-Flower-Ruby-Swirl", icon: "alcremie-flower-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1278: { name: "Alcremie-Flower-Caramel-Swirl", icon: "alcremie-flower-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1279: { name: "Alcremie-Flower-Rainbow-Swirl", icon: "alcremie-flower-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1280: { name: "Alcremie-Ribbon-Vanilla-Cream", icon: "alcremie-ribbon-vanilla-cream", baseId: 869, form: "Vanilla Cream" },
  1281: { name: "Alcremie-Ribbon-Ruby-Cream", icon: "alcremie-ribbon-ruby-cream", baseId: 869, form: "Ruby Cream" },
  1282: { name: "Alcremie-Ribbon-Matcha-Cream", icon: "alcremie-ribbon-matcha-cream", baseId: 869, form: "Matcha Cream" },
  1283: { name: "Alcremie-Ribbon-Mint-Cream", icon: "alcremie-ribbon-mint-cream", baseId: 869, form: "Mint Cream" },
  1284: { name: "Alcremie-Ribbon-Lemon-Cream", icon: "alcremie-ribbon-lemon-cream", baseId: 869, form: "Lemon Cream" },
  1285: { name: "Alcremie-Ribbon-Salted-Cream", icon: "alcremie-ribbon-salted-cream", baseId: 869, form: "Salted Cream" },
  1286: { name: "Alcremie-Ribbon-Ruby-Swirl", icon: "alcremie-ribbon-ruby-swirl", baseId: 869, form: "Ruby Swirl" },
  1287: { name: "Alcremie-Ribbon-Caramel-Swirl", icon: "alcremie-ribbon-caramel-swirl", baseId: 869, form: "Caramel Swirl" },
  1288: { name: "Alcremie-Ribbon-Rainbow-Swirl", icon: "alcremie-ribbon-rainbow-swirl", baseId: 869, form: "Rainbow Swirl" },
  1289: { name: "Sprigatito", icon: "sprigatito", baseId: 1289, form: "" },
  1290: { name: "Floragato", icon: "floragato", baseId: 1290, form: "" },
  1291: { name: "Meowscarada", icon: "meowscarada", baseId: 1291, form: "" },
  1292: { name: "Fuecoco", icon: "fuecoco", baseId: 1292, form: "" },
  1293: { name: "Crocalor", icon: "crocalor", baseId: 1293, form: "" },
  1294: { name: "Skeledirge", icon: "skeledirge", baseId: 1294, form: "" },
  1295: { name: "Quaxly", icon: "quaxly", baseId: 1295, form: "" },
  1296: { name: "Quaxwell", icon: "quaxwell", baseId: 1296, form: "" },
  1297: { name: "Quaquaval", icon: "quaquaval", baseId: 1297, form: "" },
  1298: { name: "Lechonk", icon: "lechonk", baseId: 1298, form: "" },
  1299: { name: "Oinkologne-M", icon: "oinkologne-m", baseId: 1299, form: "M" },
  1300: { name: "Oinkologne-F", icon: "oinkologne-f", baseId: 1299, form: "F" },
  1301: { name: "Tarountula", icon: "tarountula", baseId: 1301, form: "" },
  1302: { name: "Spidops", icon: "spidops", baseId: 1302, form: "" },
  1303: { name: "Nymble", icon: "nymble", baseId: 1303, form: "" },
  1304: { name: "Lokix", icon: "lokix", baseId: 1304, form: "" },
  1305: { name: "Pawmi", icon: "pawmi", baseId: 1305, form: "" },
  1306: { name: "Pawmo", icon: "pawmo", baseId: 1306, form: "" },
  1307: { name: "Pawmot", icon: "pawmot", baseId: 1307, form: "" },
  1308: { name: "Tandemaus", icon: "tandemaus", baseId: 1308, form: "" },
  1309: { name: "Maushold-Three", icon: "maushold-three", baseId: 1309, form: "Three" },
  1310: { name: "Maushold-Four", icon: "maushold-four", baseId: 1309, form: "Four" },
  1311: { name: "Fidough", icon: "fidough", baseId: 1311, form: "" },
  1312: { name: "Dachsbun", icon: "dachsbun", baseId: 1312, form: "" },
  1313: { name: "Smoliv", icon: "smoliv", baseId: 1313, form: "" },
  1314: { name: "Dolliv", icon: "dolliv", baseId: 1314, form: "" },
  1315: { name: "Arboliva", icon: "arboliva", baseId: 1315, form: "" },
  1316: { name: "Squawkabilly-Green", icon: "squawkabilly-green", baseId: 1316, form: "Green" },
  1317: { name: "Squawkabilly-Blue", icon: "squawkabilly-blue", baseId: 1316, form: "Blue" },
  1318: { name: "Squawkabilly-Yellow", icon: "squawkabilly-yellow", baseId: 1316, form: "Yellow" },
  1319: { name: "Squawkabilly-White", icon: "squawkabilly-white", baseId: 1316, form: "White" },
  1320: { name: "Nacli", icon: "nacli", baseId: 1320, form: "" },
  1321: { name: "Naclstack", icon: "naclstack", baseId: 1321, form: "" },
  1322: { name: "Garganacl", icon: "garganacl", baseId: 1322, form: "" },
  1323: { name: "Charcadet", icon: "charcadet", baseId: 1323, form: "" },
  1324: { name: "Armarouge", icon: "armarouge", baseId: 1324, form: "" },
  1325: { name: "Ceruledge", icon: "ceruledge", baseId: 1325, form: "" },
  1326: { name: "Tadbulb", icon: "tadbulb", baseId: 1326, form: "" },
  1327: { name: "Bellibolt", icon: "bellibolt", baseId: 1327, form: "" },
  1328: { name: "Wattrel", icon: "wattrel", baseId: 1328, form: "" },
  1329: { name: "Kilowattrel", icon: "kilowattrel", baseId: 1329, form: "" },
  1330: { name: "Maschiff", icon: "maschiff", baseId: 1330, form: "" },
  1331: { name: "Mabosstiff", icon: "mabosstiff", baseId: 1331, form: "" },
  1332: { name: "Shroodle", icon: "shroodle", baseId: 1332, form: "" },
  1333: { name: "Grafaiai", icon: "grafaiai", baseId: 1333, form: "" },
  1334: { name: "Bramblin", icon: "bramblin", baseId: 1334, form: "" },
  1335: { name: "Brambleghast", icon: "brambleghast", baseId: 1335, form: "" },
  1336: { name: "Toedscool", icon: "toedscool", baseId: 1336, form: "" },
  1337: { name: "Toedscruel", icon: "toedscruel", baseId: 1337, form: "" },
  1338: { name: "Klawf", icon: "klawf", baseId: 1338, form: "" },
  1339: { name: "Capsakid", icon: "capsakid", baseId: 1339, form: "" },
  1340: { name: "Scovillain", icon: "scovillain", baseId: 1340, form: "" },
  1341: { name: "Rellor", icon: "rellor", baseId: 1341, form: "" },
  1342: { name: "Rabsca", icon: "rabsca", baseId: 1342, form: "" },
  1343: { name: "Flittle", icon: "flittle", baseId: 1343, form: "" },
  1344: { name: "Espathra", icon: "espathra", baseId: 1344, form: "" },
  1345: { name: "Tinkatink", icon: "tinkatink", baseId: 1345, form: "" },
  1346: { name: "Tinkatuff", icon: "tinkatuff", baseId: 1346, form: "" },
  1347: { name: "Tinkaton", icon: "tinkaton", baseId: 1347, form: "" },
  1348: { name: "Wiglett", icon: "wiglett", baseId: 1348, form: "" },
  1349: { name: "Wugtrio", icon: "wugtrio", baseId: 1349, form: "" },
  1350: { name: "Bombirdier", icon: "bombirdier", baseId: 1350, form: "" },
  1351: { name: "Finizen", icon: "finizen", baseId: 1351, form: "" },
  1352: { name: "Palafin-Zero", icon: "palafin-zero", baseId: 1352, form: "Zero" },
  1353: { name: "Palafin-Hero", icon: "palafin-hero", baseId: 1352, form: "Hero" },
  1354: { name: "Varoom", icon: "varoom", baseId: 1354, form: "" },
  1355: { name: "Revavroom", icon: "revavroom", baseId: 1355, form: "" },
  1356: { name: "Cyclizar", icon: "cyclizar", baseId: 1356, form: "" },
  1357: { name: "Orthworm", icon: "orthworm", baseId: 1357, form: "" },
  1358: { name: "Glimmet", icon: "glimmet", baseId: 1358, form: "" },
  1359: { name: "Glimmora", icon: "glimmora", baseId: 1359, form: "" },
  1360: { name: "Greavard", icon: "greavard", baseId: 1360, form: "" },
  1361: { name: "Houndstone", icon: "houndstone", baseId: 1361, form: "" },
  1362: { name: "Flamigo", icon: "flamigo", baseId: 1362, form: "" },
  1363: { name: "Cetoddle", icon: "cetoddle", baseId: 1363, form: "" },
  1364: { name: "Cetitan", icon: "cetitan", baseId: 1364, form: "" },
  1365: { name: "Veluza", icon: "veluza", baseId: 1365, form: "" },
  1366: { name: "Dondozo", icon: "dondozo", baseId: 1366, form: "" },
  1367: { name: "Tatsugiri-Curly", icon: "tatsugiri-curly", baseId: 1367, form: "Curly" },
  1368: { name: "Tatsugiri-Droopy", icon: "tatsugiri-droopy", baseId: 1367, form: "Droopy" },
  1369: { name: "Tatsugiri-Stretchy", icon: "tatsugiri-stretchy", baseId: 1367, form: "Stretchy" },
  1370: { name: "Annihilape", icon: "annihilape", baseId: 1370, form: "" },
  1371: { name: "Clodsire", icon: "clodsire", baseId: 1371, form: "" },
  1372: { name: "Farigiraf", icon: "farigiraf", baseId: 1372, form: "" },
  1373: { name: "Dudunsparce-Two-Segment", icon: "dudunsparce-two-segment", baseId: 1373, form: "Two Segment" },
  1374: { name: "Dudunsparce-Three-Segment", icon: "dudunsparce-three-segment", baseId: 1373, form: "Three Segment" },
  1375: { name: "Kingambit", icon: "kingambit", baseId: 1375, form: "" },
  1376: { name: "Great-Tusk", icon: "great-tusk", baseId: 1376, form: "" },
  1377: { name: "Scream-Tail", icon: "scream-tail", baseId: 1377, form: "" },
  1378: { name: "Brute-Bonnet", icon: "brute-bonnet", baseId: 1378, form: "" },
  1379: { name: "Flutter-Mane", icon: "flutter-mane", baseId: 1379, form: "" },
  1380: { name: "Slither-Wing", icon: "slither-wing", baseId: 1380, form: "" },
  1381: { name: "Sandy-Shocks", icon: "sandy-shocks", baseId: 1381, form: "" },
  1382: { name: "Iron-Treads", icon: "iron-treads", baseId: 1382, form: "" },
  1383: { name: "Iron-Bundle", icon: "iron-bundle", baseId: 1383, form: "" },
  1384: { name: "Iron-Hands", icon: "iron-hands", baseId: 1384, form: "" },
  1385: { name: "Iron-Jugulis", icon: "iron-jugulis", baseId: 1385, form: "" },
  1386: { name: "Iron-Moth", icon: "iron-moth", baseId: 1386, form: "" },
  1387: { name: "Iron-Thorns", icon: "iron-thorns", baseId: 1387, form: "" },
  1388: { name: "Frigibax", icon: "frigibax", baseId: 1388, form: "" },
  1389: { name: "Arctibax", icon: "arctibax", baseId: 1389, form: "" },
  1390: { name: "Baxcalibur", icon: "baxcalibur", baseId: 1390, form: "" },
  1391: { name: "Gimmighoul-Chest", icon: "gimmighoul-chest", baseId: 1391, form: "Chest" },
  1392: { name: "Gimmighoul-Roaming", icon: "gimmighoul-roaming", baseId: 1391, form: "Roaming" },
  1393: { name: "Gholdengo", icon: "gholdengo", baseId: 1393, form: "" },
  1394: { name: "Wo-Chien", icon: "wo-chien", baseId: 1394, form: "" },
  1395: { name: "Chien-Pao", icon: "chien-pao", baseId: 1395, form: "" },
  1396: { name: "Ting-Lu", icon: "ting-lu", baseId: 1396, form: "" },
  1397: { name: "Chi-Yu", icon: "chi-yu", baseId: 1397, form: "" },
  1398: { name: "Roaring-Moon", icon: "roaring-moon", baseId: 1398, form: "" },
  1399: { name: "Iron-Valiant", icon: "iron-valiant", baseId: 1399, form: "" },
  1400: { name: "Koraidon", icon: "koraidon", baseId: 1400, form: "" },
  1401: { name: "Miraidon", icon: "miraidon", baseId: 1401, form: "" },
  1402: { name: "Tauros-Paldea-Combat", icon: "tauros", baseId: 128, form: "Paldea Combat" },
  1403: { name: "Tauros-Paldea-Blaze", icon: "tauros", baseId: 128, form: "Paldea Blaze" },
  1404: { name: "Tauros-Paldea-Aqua", icon: "tauros", baseId: 128, form: "Paldea Aqua" },
  1405: { name: "Wooper-Paldea", icon: "wooper", baseId: 194, form: "Paldea" },
  1406: { name: "Walking-Wake", icon: "walking-wake", baseId: 1406, form: "" },
  1407: { name: "Iron-Leaves", icon: "iron-leaves", baseId: 1407, form: "" },
  1408: { name: "Dipplin", icon: "dipplin", baseId: 1408, form: "" },
  1409: { name: "Poltchageist-Counterfeit", icon: "poltchageist-counterfeit", baseId: 1409, form: "Counterfeit" },
  1410: { name: "Poltchageist-Artisan", icon: "poltchageist-artisan", baseId: 1409, form: "Artisan" },
  1411: { name: "Sinistcha-Unremarkable", icon: "sinistcha-unremarkable", baseId: 1411, form: "Unremarkable" },
  1412: { name: "Sinistcha-Masterpiece", icon: "sinistcha-masterpiece", baseId: 1411, form: "Masterpiece" },
  1413: { name: "Okidogi", icon: "okidogi", baseId: 1413, form: "" },
  1414: { name: "Munkidori", icon: "munkidori", baseId: 1414, form: "" },
  1415: { name: "Fezandipiti", icon: "fezandipiti", baseId: 1415, form: "" },
  1416: { name: "Ogerpon-Teal", icon: "ogerpon-teal", baseId: 1416, form: "Teal" },
  1417: { name: "Ogerpon-Wellspring", icon: "ogerpon-wellspring", baseId: 1416, form: "Wellspring" },
  1418: { name: "Ogerpon-Hearthflame", icon: "ogerpon-hearthflame", baseId: 1416, form: "Hearthflame" },
  1419: { name: "Ogerpon-Cornerstone", icon: "ogerpon-cornerstone", baseId: 1416, form: "Cornerstone" },
  1420: { name: "Ogerpon-Teal-Tera", icon: "ogerpon-teal-tera", baseId: 1416, form: "Tera" },
  1421: { name: "Ogerpon-Wellspring-Tera", icon: "ogerpon-wellspring-tera", baseId: 1416, form: "Tera" },
  1422: { name: "Ogerpon-Hearthflame-Tera", icon: "ogerpon-hearthflame-tera", baseId: 1416, form: "Tera" },
  1423: { name: "Ogerpon-Cornerstone-Tera", icon: "ogerpon-cornerstone-tera", baseId: 1416, form: "Tera" },
  1424: { name: "Ursaluna-Bloodmoon", icon: "ursaluna-bloodmoon", baseId: 901, form: "Bloodmoon" },
  1425: { name: "Archaludon", icon: "archaludon", baseId: 1425, form: "" },
  1426: { name: "Hydrapple", icon: "hydrapple", baseId: 1426, form: "" },
  1427: { name: "Gouging-Fire", icon: "gouging-fire", baseId: 1427, form: "" },
  1428: { name: "Raging-Bolt", icon: "raging-bolt", baseId: 1428, form: "" },
  1429: { name: "Iron-Boulder", icon: "iron-boulder", baseId: 1429, form: "" },
  1430: { name: "Iron-Crown", icon: "iron-crown", baseId: 1430, form: "" },
  1431: { name: "Terapagos-Normal", icon: "terapagos-normal", baseId: 1431, form: "Normal" },
  1432: { name: "Terapagos-Terastal", icon: "terapagos-terastal", baseId: 1431, form: "Terastal" },
  1433: { name: "Terapagos-Stellar", icon: "terapagos-stellar", baseId: 1431, form: "Stellar" },
  1434: { name: "Pecharunt", icon: "pecharunt", baseId: 1434, form: "" },
  1435: { name: "Lugia-Shadow", icon: "lugia-shadow", baseId: 249, form: "Shadow" },
  1436: { name: "Mothim-Sandy", icon: "mothim", baseId: 414, form: "Sandy" },
  1437: { name: "Mothim-Trash", icon: "mothim", baseId: 414, form: "Trash" },
  1438: { name: "Scatterbug-Polar", icon: "scatterbug", baseId: 664, form: "Polar" },
  1439: { name: "Scatterbug-Tundra", icon: "scatterbug", baseId: 664, form: "Tundra" },
  1440: { name: "Scatterbug-Continental", icon: "scatterbug", baseId: 664, form: "Continental" },
  1441: { name: "Scatterbug-Garden", icon: "scatterbug", baseId: 664, form: "Garden" },
  1442: { name: "Scatterbug-Elegant", icon: "scatterbug", baseId: 664, form: "Elegant" },
  1443: { name: "Scatterbug-Meadow", icon: "scatterbug", baseId: 664, form: "Meadow" },
  1444: { name: "Scatterbug-Modern", icon: "scatterbug", baseId: 664, form: "Modern" },
  1445: { name: "Scatterbug-Marine", icon: "scatterbug", baseId: 664, form: "Marine" },
  1446: { name: "Scatterbug-Archipelago", icon: "scatterbug", baseId: 664, form: "Archipelago" },
  1447: { name: "Scatterbug-High-Plains", icon: "scatterbug", baseId: 664, form: "High Plains" },
  1448: { name: "Scatterbug-Sandstorm", icon: "scatterbug", baseId: 664, form: "Sandstorm" },
  1449: { name: "Scatterbug-River", icon: "scatterbug", baseId: 664, form: "River" },
  1450: { name: "Scatterbug-Monsoon", icon: "scatterbug", baseId: 664, form: "Monsoon" },
  1451: { name: "Scatterbug-Savanna", icon: "scatterbug", baseId: 664, form: "Savanna" },
  1452: { name: "Scatterbug-Sun", icon: "scatterbug", baseId: 664, form: "Sun" },
  1453: { name: "Scatterbug-Ocean", icon: "scatterbug", baseId: 664, form: "Ocean" },
  1454: { name: "Scatterbug-Jungle", icon: "scatterbug", baseId: 664, form: "Jungle" },
  1455: { name: "Scatterbug-Fancy", icon: "scatterbug", baseId: 664, form: "Fancy" },
  1456: { name: "Scatterbug-Pokeball", icon: "scatterbug", baseId: 664, form: "Pokeball" },
  1457: { name: "Spewpa-Polar", icon: "spewpa", baseId: 665, form: "Polar" },
  1458: { name: "Spewpa-Tundra", icon: "spewpa", baseId: 665, form: "Tundra" },
  1459: { name: "Spewpa-Continental", icon: "spewpa", baseId: 665, form: "Continental" },
  1460: { name: "Spewpa-Garden", icon: "spewpa", baseId: 665, form: "Garden" },
  1461: { name: "Spewpa-Elegant", icon: "spewpa", baseId: 665, form: "Elegant" },
  1462: { name: "Spewpa-Meadow", icon: "spewpa", baseId: 665, form: "Meadow" },
  1463: { name: "Spewpa-Modern", icon: "spewpa", baseId: 665, form: "Modern" },
  1464: { name: "Spewpa-Marine", icon: "spewpa", baseId: 665, form: "Marine" },
  1465: { name: "Spewpa-Archipelago", icon: "spewpa", baseId: 665, form: "Archipelago" },
  1466: { name: "Spewpa-High-Plains", icon: "spewpa", baseId: 665, form: "High Plains" },
  1467: { name: "Spewpa-Sandstorm", icon: "spewpa", baseId: 665, form: "Sandstorm" },
  1468: { name: "Spewpa-River", icon: "spewpa", baseId: 665, form: "River" },
  1469: { name: "Spewpa-Monsoon", icon: "spewpa", baseId: 665, form: "Monsoon" },
  1470: { name: "Spewpa-Savanna", icon: "spewpa", baseId: 665, form: "Savanna" },
  1471: { name: "Spewpa-Sun", icon: "spewpa", baseId: 665, form: "Sun" },
  1472: { name: "Spewpa-Ocean", icon: "spewpa", baseId: 665, form: "Ocean" },
  1473: { name: "Spewpa-Jungle", icon: "spewpa", baseId: 665, form: "Jungle" },
  1474: { name: "Spewpa-Fancy", icon: "spewpa", baseId: 665, form: "Fancy" },
  1475: { name: "Spewpa-Pokeball", icon: "spewpa", baseId: 665, form: "Pokeball" },
  1476: { name: "Raticate-Alola-Totem", icon: "raticate-alola", baseId: 20, form: "Totem" },
  1477: { name: "Gumshoos-Totem", icon: "gumshoos", baseId: 735, form: "Totem" },
  1478: { name: "Vikavolt-Totem", icon: "vikavolt-totem", baseId: 738, form: "Totem" },
  1479: { name: "Lurantis-Totem", icon: "lurantis", baseId: 754, form: "Totem" },
  1480: { name: "Salazzle-Totem", icon: "salazzle", baseId: 758, form: "Totem" },
  1481: { name: "Mimikyu-Totem-Disguised", icon: "mimikyu-totem-disguised", baseId: 778, form: "Disguised" },
  1482: { name: "Kommo-o-Totem", icon: "kommo-o", baseId: 784, form: "Totem" },
  1483: { name: "Marowak-Alola-Totem", icon: "marowak-alola", baseId: 105, form: "Totem" },
  1484: { name: "Ribombee-Totem", icon: "ribombee", baseId: 743, form: "Totem" },
  1485: { name: "Araquanid-Totem", icon: "araquanid", baseId: 752, form: "Totem" },
  1486: { name: "Togedemaru-Totem", icon: "togedemaru", baseId: 777, form: "Totem" },
  1487: { name: "Pikachu-Starter", icon: "pikachu-starter", baseId: 25, form: "Starter" },
  1488: { name: "Eevee-Starter", icon: "eevee-starter", baseId: 133, form: "Starter" },
  1489: { name: "Venusaur-Gmax", icon: "venusaur", baseId: 3, form: "Gmax" },
  1490: { name: "Blastoise-Gmax", icon: "blastoise-gmax", baseId: 9, form: "Gmax" },
  1491: { name: "Charizard-Gmax", icon: "charizard-gmax", baseId: 6, form: "Gmax" },
  1492: { name: "Butterfree-Gmax", icon: "butterfree-gmax", baseId: 12, form: "Gmax" },
  1493: { name: "Pikachu-Gmax", icon: "pikachu-gmax", baseId: 25, form: "Gmax" },
  1494: { name: "Meowth-Gmax", icon: "meowth-gmax", baseId: 52, form: "Gmax" },
  1495: { name: "Machamp-Gmax", icon: "machamp-gmax", baseId: 68, form: "Gmax" },
  1496: { name: "Gengar-Gmax", icon: "gengar-gmax", baseId: 94, form: "Gmax" },
  1497: { name: "Kingler-Gmax", icon: "kingler-gmax", baseId: 99, form: "Gmax" },
  1498: { name: "Lapras-Gmax", icon: "lapras-gmax", baseId: 131, form: "Gmax" },
  1499: { name: "Eevee-Gmax", icon: "eevee-gmax", baseId: 133, form: "Gmax" },
  1500: { name: "Snorlax-Gmax", icon: "snorlax", baseId: 143, form: "Gmax" },
  1501: { name: "Garbodor-Gmax", icon: "garbodor-gmax", baseId: 569, form: "Gmax" },
  1502: { name: "Melmetal-Gmax", icon: "melmetal-gmax", baseId: 809, form: "Gmax" },
  1503: { name: "Rillaboom-Gmax", icon: "rillaboom-gmax", baseId: 812, form: "Gmax" },
  1504: { name: "Cinderace-Gmax", icon: "cinderace-gmax", baseId: 815, form: "Gmax" },
  1505: { name: "Inteleon-Gmax", icon: "inteleon-gmax", baseId: 818, form: "Gmax" },
  1506: { name: "Corviknight-Gmax", icon: "corviknight-gmax", baseId: 823, form: "Gmax" },
  1507: { name: "Orbeetle-Gmax", icon: "orbeetle-gmax", baseId: 826, form: "Gmax" },
  1508: { name: "Drednaw-Gmax", icon: "drednaw-gmax", baseId: 834, form: "Gmax" },
  1509: { name: "Coalossal-Gmax", icon: "coalossal-gmax", baseId: 839, form: "Gmax" },
  1510: { name: "Flapple-Gmax", icon: "flapple-gmax", baseId: 841, form: "Gmax" },
  1511: { name: "Appletun-Gmax", icon: "appletun", baseId: 842, form: "Gmax" },
  1512: { name: "Sandaconda-Gmax", icon: "sandaconda-gmax", baseId: 844, form: "Gmax" },
  1513: { name: "Toxtricity-Amped-Gmax", icon: "toxtricity-amped-gmax", baseId: 849, form: "Gmax" },
  1514: { name: "Toxtricity-Low-Key-Gmax", icon: "toxtricity-low-key-gmax", baseId: 849, form: "Gmax" },
  1515: { name: "Centiskorch-Gmax", icon: "centiskorch-gmax", baseId: 851, form: "Gmax" },
  1516: { name: "Hatterene-Gmax", icon: "hatterene-gmax", baseId: 858, form: "Gmax" },
  1517: { name: "Grimmsnarl-Gmax", icon: "grimmsnarl-gmax", baseId: 861, form: "Gmax" },
  1518: { name: "Alcremie-Gmax", icon: "alcremie-gmax", baseId: 869, form: "Gmax" },
  1519: { name: "Copperajah-Gmax", icon: "copperajah-gmax", baseId: 879, form: "Gmax" },
  1520: { name: "Duraludon-Gmax", icon: "duraludon-gmax", baseId: 884, form: "Gmax" },
  1521: { name: "Urshifu-Single-Strike-Gmax", icon: "urshifu-single-strike-gmax", baseId: 892, form: "Gmax" },
  1522: { name: "Urshifu-Rapid-Strike-Gmax", icon: "urshifu-rapid-strike-gmax", baseId: 892, form: "Gmax" },
  1523: { name: "Mimikyu-Busted-Totem", icon: "mimikyu-busted-totem", baseId: 778, form: "Totem" },
  1524: { name: "Clefable-Mega", icon: "clefable", baseId: 36, form: "Mega" },
  1525: { name: "Victreebel-Mega", icon: "victreebel", baseId: 71, form: "Mega" },
  1526: { name: "Starmie-Mega", icon: "starmie", baseId: 121, form: "Mega" },
  1527: { name: "Dragonite-Mega", icon: "dragonite", baseId: 149, form: "Mega" },
  1528: { name: "Meganium-Mega", icon: "meganium", baseId: 154, form: "Mega" },
  1529: { name: "Feraligatr-Mega", icon: "feraligatr", baseId: 160, form: "Mega" },
  1530: { name: "Skarmory-Mega", icon: "skarmory", baseId: 227, form: "Mega" },
  1531: { name: "Froslass-Mega", icon: "froslass", baseId: 478, form: "Mega" },
  1532: { name: "Emboar-Mega", icon: "emboar", baseId: 500, form: "Mega" },
  1533: { name: "Excadrill-Mega", icon: "excadrill", baseId: 530, form: "Mega" },
  1534: { name: "Scolipede-Mega", icon: "scolipede", baseId: 545, form: "Mega" },
  1535: { name: "Scrafty-Mega", icon: "scrafty", baseId: 560, form: "Mega" },
  1536: { name: "Eelektross-Mega", icon: "eelektross", baseId: 604, form: "Mega" },
  1537: { name: "Chandelure-Mega", icon: "chandelure", baseId: 609, form: "Mega" },
  1538: { name: "Chesnaught-Mega", icon: "chesnaught", baseId: 652, form: "Mega" },
  1539: { name: "Delphox-Mega", icon: "delphox", baseId: 655, form: "Mega" },
  1540: { name: "Greninja-Mega", icon: "greninja", baseId: 658, form: "Mega" },
  1541: { name: "Pyroar-Mega", icon: "pyroar", baseId: 668, form: "Mega" },
  1542: { name: "Malamar-Mega", icon: "malamar", baseId: 687, form: "Mega" },
  1543: { name: "Dragalge-Mega", icon: "dragalge", baseId: 691, form: "Mega" },
  1544: { name: "Hawlucha-Mega", icon: "hawlucha", baseId: 701, form: "Mega" },
  1545: { name: "Floette-Mega", icon: "floette", baseId: 670, form: "Mega" },
  1546: { name: "Barbaracle-Mega", icon: "barbaracle", baseId: 689, form: "Mega" },
  1547: { name: "Zygarde-Mega", icon: "zygarde-mega", baseId: 718, form: "Mega" },
  1548: { name: "Drampa-Mega", icon: "drampa", baseId: 780, form: "Mega" },
  1549: { name: "Falinks-Mega", icon: "falinks", baseId: 870, form: "Mega" },
  1550: { name: "Heatran-Mega", icon: "heatran", baseId: 485, form: "Mega" },
  1551: { name: "Darkrai-Mega", icon: "darkrai", baseId: 491, form: "Mega" },
  1552: { name: "Zeraora-Mega", icon: "zeraora-mega", baseId: 807, form: "Mega" },
  1553: { name: "Raichu-Mega-X", icon: "raichu", baseId: 26, form: "Mega X" },
  1554: { name: "Raichu-Mega-Y", icon: "raichu", baseId: 26, form: "Mega Y" },
  1555: { name: "Chimecho-Mega", icon: "chimecho", baseId: 358, form: "Mega" },
  1556: { name: "Absol-Mega-Z", icon: "absol-mega", baseId: 359, form: "Z" },
  1557: { name: "Staraptor-Mega", icon: "staraptor", baseId: 398, form: "Mega" },
  1558: { name: "Garchomp-Mega-Z", icon: "garchomp-mega", baseId: 445, form: "Z" },
  1559: { name: "Lucario-Mega-Z", icon: "lucario-mega", baseId: 448, form: "Z" },
  1560: { name: "Golurk-Mega", icon: "golurk", baseId: 623, form: "Mega" },
  1561: { name: "Meowstic-M-Mega", icon: "meowstic-m", baseId: 678, form: "Mega" },
  1562: { name: "Meowstic-F-Mega", icon: "meowstic-f", baseId: 678, form: "Mega" },
  1563: { name: "Crabominable-Mega", icon: "crabominable", baseId: 740, form: "Mega" },
  1564: { name: "Golisopod-Mega", icon: "golisopod", baseId: 768, form: "Mega" },
  1565: { name: "Magearna-Mega", icon: "magearna", baseId: 801, form: "Mega" },
  1566: { name: "Magearna-Original-Mega", icon: "magearna-original", baseId: 801, form: "Mega" },
  1567: { name: "Scovillain-Mega", icon: "scovillain-mega", baseId: 1340, form: "Mega" },
  1568: { name: "Baxcalibur-Mega", icon: "baxcalibur", baseId: 1390, form: "Mega" },
  1569: { name: "Tatsugiri-Curly-Mega", icon: "tatsugiri-curly-mega", baseId: 1367, form: "Mega" },
  1570: { name: "Tatsugiri-Droopy-Mega", icon: "tatsugiri-droopy-mega", baseId: 1367, form: "Mega" },
  1571: { name: "Tatsugiri-Stretchy-Mega", icon: "tatsugiri-stretchy-mega", baseId: 1367, form: "Mega" },
  1572: { name: "Glimmora-Mega", icon: "glimmora-mega", baseId: 1359, form: "Mega" },
  1573: { name: "Egg", icon: "egg", baseId: 1573, form: "" },
};
